import { title } from '@t2/QaimPackage';

export default {
  auditFieldsErrors: {
    attachments: 'قام المدقق بالتوصية بتعديل المرفقات، من فضلك عدلها اولا.',
    caseType: 'قام المدقق بالتوصية بتعديل نوع القضية من فضلك عدلها اولا.',
    court: 'قام المدقق بالتوصية بتعديل المحكمة من فضلك عدلها اولا.',
    demands: 'قام المدقق بالتوصية بتعديل الطلبات من فضلك عدلها اولا.',
    proofs: 'قام المدقق بالتوصية بتعديل الأسانيد من فضلك عدلها اولا.',
    subject: 'قام المدقق بالتوصية بتعديل موضوع الدعوى من فضلك عدلها اولا.',
  },
  demoPage: { pageTitle: 'Demo Page for components' },
  caseTypeTree: {
    title: 'الشجرات القضائية',
    refresh: 'تحديث',
    version: 'الإصدار',
    createdDate: 'تاريخ التحديث',
    status: 'الحالة',
    activate: 'تفعيل',
    active: 'مفعل',
    caseTypeErr: 'نوع الدعوى غير متاح',
    caseTypeReq: 'نوع الدعوى مطلوب ',
    ActivatedDate: 'تاريخ التفعيل',
    caseClassificationErr: 'التصنيف الرئسيي غير متاح',
    caseCategoryErr: 'التصنيف الفرعى غير متاح',
    caseTreeBtn: 'المساعدة على اختيار التصنيف',
    caseTreeBtnOld: 'ارغب فى الاختيار يدوياً',

  },

  common: {
    backToOldVersion: 'العودة للإصدار القديم',
    save: 'حفظ',
    accept: 'قبول',
    AcceptAndApprove: 'قبول و موافقة',
    reject: 'رفض',
    agree: 'موافق',
    notAgree: 'غير موافق',
    saveAndSend: 'حفظ و إرسال',
    saveAndSendReply: 'حفظ و إرسال الرد',
    saveAndContinuous: 'حفظ و استمرار',
    saveAndContinuousLater: 'حفظ واستكمال لاحقاً',
    cancel: 'إلغاء',
    close: 'إغلاق',
    add: 'إضافة',
    addOriginalParty: 'إضافة طرف أصيل',
    addRepresentative: 'إضافة ممثل',
    update: 'تعديل',
    select: 'تحديد',
    redirectToExternalService: 'الإنتقال إلي الخدمة',
    redirectExternalServiceUrl: 'رابط الإنتقال إلي الخدمة',
    redirectExternalServiceUrlMsg: 'يمكنك تقديم طلب انهائي لدوائر الاوقاف و المواريث بالأحساء و القطيف من  خلال النقر على الإنتقال إلي الخدمة',
    back: 'رجوع',
    backToHome: 'العودة للصفحة الرئيسية',
    next: 'التالي',
    previous: 'السابق',
    remove: 'حذف',
    view: 'معاينة',
    show: 'عرض',
    print: 'طباعة',
    download: 'تحميل',
    type: 'النوع',
    code: 'الرقم',
    date: 'التاريخ',
    the: 'ال',
    or: 'أو',
    all: 'الكل',
    return: 'عودة',
    notes: 'ملاحظات',
    cancelReason: 'سبب الإلغاء',
    returnToMainRequest: 'العودة إلى الطلب الرئيسي/الإجراء',
    selectedOptions: count => `(+${count} اختيار)`,
    removeConfirmation: 'تأكيد الحذف',
    removeConfirmationMessage: 'لا يمكن استرجاع البيانات بعد الحذف. هل ترغب بتأكيد الحذف؟',
    dynamicRemoveConfirmationMessage: name =>
      `لا يمكن استرجاع ${name} بعد حذفه. هل ترغب بتأكيد حذف ${name}؟`,
    delete: 'حذف',
    check: 'تحقق',
    search: 'البحث',
    lawsuitCategoriesSearch: 'البحث في تصانيف الدعوى',
    searchPlaceholder: 'الكلمات المفتاحية',
    searchResults: 'نتائج البحث',
    tryAgain: 'حاول مرة أخرى',
    saveAndContinue: 'حفظ ومتابعة',
    representativeRole: 'صفة الممثل',
    representativePartyType: 'نوع الممثل',
    person: 'فرد',
    representative: 'ممثل',
    other: 'أخرى',
    authentication: 'مصادقة',
    scan: 'مسح المرفق',
    upload: 'اضغط هنا لرفع المرفق',
    loading: 'جاري التحميل',
    noData: 'عفواً، لم يتم العثور على بيانات',
    selectBoxNoData: 'لا يوجد بيانات',
    rowsPerPage: 'الصفوف في كل صفحة',
    addToCase: 'إضافة إلي ملف القضية',
    correctionDecisions: 'قرارات التصحيح',
    firstDegreeJudgment: 'حكم الدرجة الأولي',
    casePartyRoles: {
      prosecutor: 'مدعي',
      agent: 'وكيل',
      defendant: 'مدعى عليه',
      wiseness: 'شاهد',
      lawyer: 'محامي',
      relative: 'أحد الأقارب',
      journalist: 'صحفى',
      companyRep: 'مندوب شركة',
      other: 'أخرى',
      representative: 'ممثل',
      regent: 'وصي',
      liquidator: 'مصفي',
      judicialGuard: 'حارس قضائي',
      translator: 'مترجم',
      allAttendance: 'كل الحضور',
      circle: 'الدائرة',
      otherAttendant: 'حاضر',
      editor: 'معدل',
      execRequester: '10001',
      requesterAgainstHim: '10002',
      guardian: 'ولي',
      husband: 'زوج',
      wife: 'زوجة',
      terminator: 'منهي',
      recommender: 'موصي',
      minor: 'قاصر',
      dead: 'متوفى',
      inheritor: 'مورث (متوفى)',
      cessationObserver: 'ناظر الوقف',
      reconsideredFromNonCaseParty: 'ملتمس من خارج أطراف الدعوى',
    },
    deleteRepresentative: 'حذف الممثل',
    prosecutor: 'مدعي',
    defendant: 'مدعى عليه',
    theProsecutor: 'المدعي',
    theProsecutorList: 'قائمة المدعين',
    theDefendant: 'المدعى عليه',
    theDefendantList: 'قائمة المدعى عليهم',
    addProsecutor: 'إضافة مدعي',
    addDefendant: 'إضافة مدعى عليه',
    yes: 'نعم',
    no: 'لا',
    savedSuccessfully: 'تم الحفظ بنجاح',
    verificationSucceeded: 'تم التحقق بنجاح',
    verificationFailed: 'فشلت عملية التحقق',
    uploadFailed: 'فشل عملية رفع الملف',
    uploadSuccess: 'تم إرفاق الملف بنجاح',
    caseReplySavedSuccessfully: 'تم حفظ الرد على القضية بنجاح',
    failedToSaveReply: 'فشل حفظ الرد على القضية',
    total: 'الإجمالي',
    showLawsuitAction: 'عرض صحيفة الدعوى',
    hijri: 'هجري',
    gregorian: 'ميلادي',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    cancelConfirmation: 'تأكيد الإلغاء',
    cancelConfirmationMessage: 'هل ترغب بتأكيد الإلغاء؟',
    and: 'و',
    warning: 'تنبيه',
    filter: 'تصفية',
    agree: 'موافق',
    confirmCancelRequest: 'هل انت متأكد من إلغاء الطلب؟',
    confirmRequestCancellation: 'تأكيد إلغاء الطلب',
    confirmRequestSubmission: 'تأكيد إرسال الطلب',
    confirmSubmitRequest: 'هل انت متأكد من إرسال الطلب؟',
    confirmSaveRequest: 'تأكيد حفظ الطلب',
    confirmationSaveMessage: 'هل انت متأكد من حفظ الطلب؟',
    clickHere: 'اضغط هنا',
    confirmationSendRequest: 'تأكيد إرسال الطلب',
    continue: 'متابعة',
    inCompleteReasons: 'أسباب عدم الاكتمال',
    noReasonsToDisplay: 'لا يوجد أسباب لعرضها',
    dearApplicant: 'عزيزي المستفيد',
    byClickHere: 'الضغط هنا',
    new: 'جديد',
    submitRequest: 'تقديم الطلب',
    abandoned: 'متنازل عنه',
    notFound: 'عفواً البيانات المدخلة غير صحيحة يرجى التحقق من البيانات.',
    underConstruction: 'عفواً الخدمة تحت الانشاء.',
    selectOption: 'يرجى الاختيار',
    returnToRequests: 'العودة لقائمة الطلبات',
    criminalAttachment: 'عفوا، لا يمكن تحميل المرفق',
    criminalAttachmentTitle: 'عرض المرفق',
    resend: 'تحديث الطلب',
    confirmationUpdateRequest: 'تأكيد تحديث الطلب',
  },
  generalSpecializedLocationCourtOptions: {
    conditionFound: 'يوجد شرط بين الطرفين لتحديد مكان إقامة الدعوى',
    PartiesCompanyRelated: 'أحد أطراف الدعوى شركة والنزاع متعلق بفرع الشركة',
    other: 'غير ذلك',
    PartiesGovernmentRelated: 'أحد أطراف الدعوى جهة حكومية والنزاع متعلق بفرع الجهة',

  },
  shared: { shouldAddedToList: listName => `يجب إضافة القيمة الى قائمة ${listName}` },
  settingsBox: {
    systemColors: 'ألوان النظام',
    fieldsSize: 'حجم الحقول',
    normalFields: 'عادية',
    bigFields: 'كبيرة',
    systemScheme: 'شكل النظام',
    systemDark: 'مظلم',
    systemLight: 'فاتح',
  },
  dataGrid: {
    showAdvancedSearch: 'اضغط لإظهار خيارات البحث المتقدم',
    hideAdvancedSearch: 'اضغط لإخفاء خيارات البحث المتقدم',
  },
  errorPages: {
    forbidden: { title: 'ليس لديك الصلاحية لرؤية هذه الصفحة' },
    pageNotFound: { title: 'الصفحة غير موجودة' },
  },
  lawsuitRequest: {
    requestInfo: {
      requestCode: 'رقم الطلب: ',
      caseCode: 'رقم القضية: ',
      court: 'المحكمة: ',
      requestDate: 'التاريخ: ',
      requestType: 'نوع الطلب: طلب رفع دعوى قضائية',
      status: 'حاله الطلب: ',
      caseDetails: 'تفاصيل القضية',
      caseData: 'بيانات القضية',
      sectionApplicantToApply: 'الطرف المراد تمثيله',
      type: 'النوع',
      unifiedNumber: 'الرقم الوطني الموحد',
      socialId: 'رقم الهوية',
      check: 'تحقق',
      partyName: 'اسم الطرف',
      partyNameNotFound: 'البيانات المدخلة خاطئة، يرجى التحقق من الرقم المدخل',
      role: 'صفته',
      typeOfParty: 'نوعه',
      socialIdInfo: 'المطلوب هو رقم الهوية او الرقم الموحد .',
    },
    authentication: {
      toAuthenticatedOnLawsuitRequestMustBeChoice: 'للمصادقة على صحيفة الدعوى يرجى الإختيار',
      acceptAuthentication: 'في حالة تقديم الطلب سترفع صحيفة الدعوى إلي وزارة العدل ولا يمكن تعديل الطلب لاحقاً',
      refusedAuthentication: 'في حال إلغاء الطلب لن يتم رفع صحيفة الدعوى إلي وزارة العدل',
      editAuthenticationData: 'في حال طلب التعديل علي صحيفة الدعوى سيرسل الطلب إلى الموظف المختص بالجهة الصحية للمراجعة ',
      beneficiaryNote: 'ملاحظات المستفيد',
      authenticationAcceptanceSuccessfully: 'تمت المصادقة بنجاح',
      invalidCasePartyRelatedToInheritor: 'لا يمكن إتاحة الخدمة لوجود قاصر او هوية لا تقبل للمصادقة .. يرجى اضافة الورثة بشكل يدوي ..',
      checkPartyAuthenticationError: 'حدث خطأ أثناء التحقق من مصادقة الورثة',
    },
    reconciliationInfo: {
      title: 'بيانات الصلح',
      reconciliationRequestCode: 'رقم طلب الصلح',
      reconciliationFile: 'مرفق محضر الصلح',
      note: 'رقم الصلح هو الرقم الصادر من الصك أو السند من نظام تراضي',
      reconciliationPartiesStatusBefore: 'هل سبق مداولة الصلح بين أطراف الدعوى لنفس المطالبة',
      whenReconciliationOccured: 'أين تمت مداولة الصلح',
      invalidReconciliationNumber: 'عفواً ،يرجى إدخال الرقم الصحيح الصادر من مركز المصالحة ( منصة تراضي ) لنفس المطالبة',
      reconciliationUnderProcessingStatusResult: 'يجب انتهاء اجراء الصلح في مركز المصالحة ( منصة تراضي ) لاستكمال تقديم صحيفة الدعوى',
      reconciliationSuccessfully: 'يرجى تقديم السند الصادر من مركز المصالحة للتنفيذ وذلك لانتهاء اجراء النزاع لنفس المطالبة',
      intentionForReconciliation: 'هل ترغب باللجوء للمصالحة؟',
      verificationSucceededUploadFailed: 'تم التحقق بنجاح ولم يتم إرفاق مرفق الصلح',
      verificationSucceededUploadSucceeded: 'تم التحقق بنجاح وتم إرفاق مرفق الصلح',
    },
    step2: {
      head1Prosecuters: 'المدعون',
      head1Defendants: 'المدعى عليهم',
      head2Prosecuters: 'يمكنك هنا إضافة المدعين',
      head2Defendants: 'المدعى عليهم',
      head2Common: 'قبل إضافة الممثلين عنهم',
    },
    currentUserAsCaseParty: {
      modalTitle: 'استكمال البيانات',
      confirmTitle: 'إضافة مدعي',
      confirmMessage: 'هل تريد إضافة بياناتك كمدعي؟',
      requiredAction: 'إضافة أطراف الدعوى',
      actionType: 'خيارات إضافة البيانات المطلوبة',
      chooseActionType: 'إختر من القائمة',
      addNewCaseParty: 'إضافة بيانات المدعي / المدعين بأنواعها وتفاصيلها',
      addNewCasePartyDescription1: 'اختيار',
      addNewCasePartyDescription2: 'نوع المدعي / المدعين',
      addNewCasePartyDescription3: 'من خلال هذه الاختيارات ( فرد- شركة- مؤسسة - .. ) ويتم إدخال جميع البيانات الخاصة بكل نوع تم إضافته',
      addCurrentUserAsProsecuter: 'جلب بيانات المدعي - أبشر',
      addCurrentUserAsProsecuterDescription1: 'سيتم جلب بياناتك من',
      addCurrentUserAsProsecuterDescription2: 'أبشر',
      addCurrentUserAsProsecuterDescription3: '، و إستكمال البيانات التالية :',
      addCurrentUserAsAgent: 'إضافة مدعي بواسطة وكيله',
      addCurrentUserAsAgentDescription1: 'إضافة مدعي و',
      addCurrentUserAsAgentDescription2: 'وكيله',
      addCurrentUserAsAgentDescription3: 'عن طريق إدخال رقم الوكالة، و بعدها يقوم النظام بعرض قائمة بأطراف الوكالة ليمكنك إختيار من ترغب بإضافته لصحيفة الدعوى، و إستكمال البيانات التالية :',
      addCurrentUserAsLawyer: 'إضافة مدعي بواسطة محاميه',
      addCurrentUserAsLawyerDescription1: 'إضافة مدعي و',
      addCurrentUserAsLawyerDescription2: 'محاميه',
      addCurrentUserAsLawyerDescription3: 'عن طريق إدخال رقم الوكالة، و بعدها يقوم النظام بعرض قائمة بأطراف الوكالة ليمكنك إختيار من ترغب بإضافته لصحيفة الدعوى، و إستكمال البيانات التالية :',
      commercialRegistrationNumber: 'سجل تجاري',
      commercialRegistrationTypeName: 'نوع السجل التجارى',
      agentInfo: {
        attorneyInfo: 'بيانات الوكالة',
        attorneyNumber: 'رقم الوكالة',
        attorneyType: 'نوعها',
        attorneySource: 'مصدرها',
        clientsName: 'اسماء الموكلين',
        agentName: 'اسم الوكيل',
        lawyerName: 'اسم المحامي',
        agentIsOriginalCaseParty: 'إضافة الوكيل كطرف أصيل',
        agentIsOriginalCasePartyNote: 'تنبيه هام: باختيارك الإضافة تكون قد أضفت نفسك كطرف مدعي في القضية',
        lawyerIsOriginalCaseParty: 'إضافة المحامي كطرف أصيل',
        completeInfo: 'إكمال بيانات',
        nationalAddressError: name => `فشل جلب العنوان الوطني لطرف الدعوى ${name}`,
        lawyerCheckError: 'رخصة المحاماه غير سارية',
      },
      najizCitizinMsg: 'يمكنك استخدام ناجز - المحامين لتقديم طلب صحيفة الدعوى',
      najizLawyerMsg: 'يمكنك استخدام ناجز - الافراد لتقديم طلب صحيفة الدعوى',

    },
    incompleteReasons: { title: ' أسباب عدم الاكتمال' },
    reasons: { title: '  الأسباب ' },

    serviceNotAvailable: 'الخدمة غير متاحة',
  },
  embassy: {
    title: 'بيانات السفارة / القنصلية',
    name: 'اسم جهة السفارة / القنصلية',
  },
  profession: {
    title: 'جهة العمل',
    type: 'نوع جهة العمل',
    governmentAttorneys: 'الجهات الحكومية',
    profession: 'المهنة/الوظيفة',
    workingPlaceName: 'اسم جهة العمل',
    diplomaticAuthority: 'الجهات المركزية',
    subAuthority: 'الجهات الفرعية',
  },
  governmentAttorney: {
    title: 'بيانات الجهة الحكومية',
    governmentAttorneyName: 'اسم الجهة الحكومية',
    name: 'اسم الهيئه الفرعية',
    letterNumber: 'رقم الخظاب',
    letterDate: 'تاريخ الخطاب',
    letterSource: 'مصدر الخطاب',
  },
  association: {
    title: 'بيانات الجمعية',
    associationName: 'اسم الجمعية',
  },
  internationalBodies: {
    title: 'بيانات الهيئات الدولية / الإنسانية',
    name: 'اسم جهة الهيئة دولية / إنسانية',
  },
  nationalAddress: {
    nationalAddresses: 'العناوين المسجلة',
    title: 'العنوان الوطني',
    country: 'الدولة',
    city: 'المدينة',
    district: 'الحي',
    postalCode: 'الرمز البريدي',
    poBox: 'الرقم الإضافي',
    buildingNumber: 'رقم المبنى',
    street: 'اسم الشارع',
    flatNumber: 'رقم الوحدة',
    str: 'شارع',
    buildingNum: 'مبنى رقم',
  },
  personInformation: {
    title: 'بيانات الفرد الشخصية',
    checkMoiPersonalInfoService: 'خدمة التحقق من الافراد',
    checkMoiPersonalInfo: 'بيانات التحقق',
    socialId: 'رقم الهوية',
    age: 'العمر',
    male: 'ذكر',
    female: 'أنثى',
    socialType: 'نوع الهوية',
    social: 'رقم الهوية',
    nationality: 'الجنسية',
    name: 'الاسم',
    firstName: 'الاسم',
    fatherName: 'اسم الأب',
    grandFatherName: 'اسم الجد',
    grandFatherNamePlaceHolder: 'اكتب اسم الجد',
    familyName: 'اسم العائلة',
    sex: 'النوع',
    passport: 'جواز السفر',
    passportDate: 'تاريخ اصدار جواز السفر',
    passportSource: 'مصدر جواز السفر',
    dateOfBirth: 'تاريخ الميلاد',
    check: 'تحقق',
    socialIdIsRequired: 'يجب إدخال رقم الهوية',
    dateOfBirthIsRequired: 'يجب إدخال تاريخ الميلاد',
    socialIdTypeInValid: 'نوع الهوية غير صحيح',
    checkPersonalInfoError: 'البيانات غير مسجلة بوزارة الداخلية',
    commercialRegistrationNotVerified: 'تم إضافة البيانات  يدوياً على مسؤلية المستخدم',
    needsTranslator: 'بحاجة إلى مترجم',
    chooseTranslationLanguage: 'اختر لغة الترجمة المطلوبة',
    chooseSubTranslationLanguage: 'اختر لغة الترجمة الفرعية',
    nationalIdDefendantNoticeText: 'يجب أن يتم إدخال رقم الهوية مع الاسم الاول أو تاريخ الميلاد وضغط ايقونة التحقق لجلب بيانات المدعى عليه',
    regularResidencyDefendantNoticeText: 'يجب أن يتم إدخال رقم الهوية مع تاريخ الميلاد وضغط ايقونة التحقق لجلب بيانات المدعى عليه',
    regularResidencyProsecutorNoticeText: 'يجب أن يتم إدخال رقم الهوية مع تاريخ الميلاد وضغط ايقونة التحقق لجلب بيانات المدعي',
    regularResidencyNoticeText: 'يجب أن يتم إدخال رقم الهوية مع تاريخ الميلاد وضغط ايقونة التحقق لجلب بيانات',
    familyRelationshipNoticeText: 'يجب التحقق من صلة القرابة',
    checkHeirSaqInfoError: 'يجب التحقق من رقم الصك',
    selectHeirsFirst: 'يجب إضافة وارث واحد على الاقل',
    attorneyVerificationError: party =>
      `عفوًا، يُرجى إعادة التحقق من بيانات الوكالة رقم ${party.attorneyNumber} عن الطرف ${party.fullName}.`,
  },
  prisonerInformation: {
    prisoner: 'سجين',
    prisonerStatus: 'حاله السجين',
    prisonerNumber: 'رقم السجين',
    prisonId: 'رمز السجن',
    prisonName: 'اسم السجن',
  },
  guardianForm: {
    title: 'بيانات الولي',
    minorTypeId: 'حالة القاصر',
    guardianshipNumber: 'رقم صك الولاية',
    instrumentSource: 'مصدر الصك',
    isManualDeed: 'صك يدوي',
    relativeTypeId: 'صلة القرابة',
    invalidNumber: 'رقم صك الولاية غير صحيح',
    invalidRelation: 'عفواً، ان العلاقة بين المدعي و الممثل غير صحيحة',
  },
  regentForm: {
    title: 'بيانات الوصي',
    minorTypeId: 'حالة القاصر',
    regencyNumber: 'رقم صك الوصاية',
    instrumentSource: 'مصدر الصك',
    isManualDeed: 'صك يدوي',
    relativeTypeId: 'صلة القرابة',
    invalidNumber: 'رقم صك الوصاية غير صحيح',
  },
  agentForm: {
    title: 'بيانات الوكالة',
    wrongCode: 'رقم الوكالة غير صحيحة.',
    successCode: 'تم تحديث بيانات الوكالة بنجاح',
    removeAttorneyMessage: 'تم حذف الوكالة بنجاح',
  },
  lawyerForm: {
    title: 'بيانات المحامي',
    multiLevelAttorney: 'وكالة عن وكالة',
    agentSocialId: 'رقم هوية الوكيل الأول',
    approvalNo: 'رقم التصديق',
    approvedFromMOJ: 'مصدق من وزارة العدل',
    approvedFromMOFA: 'مصدق من وزارة الخارجية',
    isTraineeLawyer: 'محامٍ متدرب',
    mainLawyerSocialId: 'رقم هوية المحامي الأساسي',
    mainAttorneyNumber: 'رقم الوكالة الأصلية',
    mainAttorneyApprovalNumber: 'رقم الوكالة الأصلية/التصديق',
    infoError: 'بيانات المحامي غير صحيحة',
    mainAndTraineeLawyerEqualSocialIdsError: 'يجب الا تكون هوية المحامي الأساسي نفس هوية المحامي المتدرب',
  },
  liquidatorForm: {
    title: 'بيانات حكم تعيين المصفى',
    judgementNumber: 'رقم الحكم للمصفي',
    judgementDate: 'تاريخ الحكم',
    judgementSource: 'مصدر الصك',
    invalidNumber: 'رقم الحكم غير صحيح',
  },
  judicialGuardForms: {
    title: 'بيانات حكم تعيين الحارس القضائي',
    judgementNumber: 'رقم الحكم للحارس القضائي',
  },
  companyAttorney: { title: 'بيانات الوكالة' },
  attorney: {
    title: 'بيانات الوكالة',
    type: 'نوع الوكالة',
    number: 'رقم الوكالة',
    source: 'مصدر الوكالة',
    year: 'سنة الوكالة',
    isRelative: 'أحد الأقارب حتى الدرجة الرابعة',
    relativeDescription: 'صلة القرابة',
    approvalNumber: 'رقم التصديق',
    originalAttorneyCode: 'رقم الوكالة الأساسية',
    secondaryAttorneyCode: 'رقم الوكالة الفرعية',
    isApprovedFromMofa: 'مصدق من وزارة الخارجية',
    isApprovedFromMoj: 'مصدق من وزارة العدل',
    infoError: 'بيانات الوكالة غير صحيحة',
    attorneyModalTitle: 'محتوى نص الوكالة',
    attorneyText: 'نص الوكالة',
    showAttorneyText: 'إظهار نص الوكالة',
    invalidNumber: 'رقم الوكالة غير صحيح',
    showAttorneyError: 'الوكالة غير سارية أو ملغية يرجى إعادة إدخال بيانات الوكالة مرة أخرى',
    missingItem700: 'لا يمكن إضافة الوكالة لأنه لم يتم التوكيل ببند (المطالبة وإقامة الدعاوى)، يرجى مراجعة الجهة المصدرة للوكالة',
    missingItem701: 'لا يمكن إضافة الوكالة لأنه لم يتم التوكيل ببند (المرافعة و المدافعة)، يرجى مراجعة الجهة المصدرة للوكالة',
    missingItem702: 'لا يمكن إضافة الوكالة لأنه لم يتم التوكيل ببند (سماع الدعاوى والرد عليها)، يرجى مراجعة الجهة المصدرة للوكالة',
    attorneyDoc: 'مرفق الوكالة',
    updateAttorneyDetailsModalTitle: 'تحديث بيانات الوكالة',
    DeleteTheAgencyOnThisCase: 'انتهاء العلاقة بالقضية ',
    DeleteTheAgencyOnThisCaseMassage: 'في حال حذف الوكالة على هذه القضية، لن تظهر القضية لديك ضمن قائمة القضايا.',
    updateAttorneyDetailsText: 'عزيزي المستفيد، نأمل تحديث بيانات الوكالة للدخول على القضية',
    submitRemoveRepresentativeRequest: 'طلب حذف القضية من حساب الممثل',
    clientsName: 'اسماء الموكلين',
    originalCasePartyName: 'اسم الطرف الاصيل',
    representationTypes: 'نوع التمثيل',
    representative: 'وكيل',
    lawyer: 'محامي',
    traineeLawyer: 'محامي متدرب',
    removeRepresentativeText: 'في حال حذف الوكالة على هذه القضية، لن تظهر القضية لديك ضمن قائمة القضايا.',
  },
  contact: {
    title: 'بيانات الاتصال',
    mobile: ' الهاتف الجوال',
    workPhone: 'هاتف العمل',
    homePhone: 'الهاتف المنزلي',
    fax: 'رقم الفاكس',
    email: 'البريد الالكتروني',
  },
  address: {
    address: 'العنوان',
    country: 'الدولة',
    region: 'المنطقة',
    city: 'المدينة',
    district: 'الحي',
    buildingNumber: 'رقم المبنى',
    street: 'اسم الشارع',
    flatNumber: 'رقم الوحدة',
    center: 'المركز',
    longitude: 'خط الطول',
    latitude: 'خط العرض',
    specifyAddressonMap: 'تحديد العنوان على الخريطة',
    describe: 'الوصف',
    location: 'العنوان على الخريطة',
    promiseNotKnowDefendantAddress: 'تعهد المدعي بعدم معرفة عنوان المدعى عليه',
  },
  organizationData: {
    title: 'بيانات المؤسسة',
    name: 'اسم المؤسسة',
    socialId: 'هوية صاحب المؤسسة',
    activities: 'نشاط المؤسسة',
    commercialRegistrationNumberOrUnifiedNumber: 'رقم السجل التجاري/الرقم الوطني الموحد',
    commercialRegistrationNumber: 'رقم السجل التجاري',
    managerTitle: 'بيانات صاحب المؤسسة',
    organizationManager: 'صاحب المؤسسة',
    unifiedNumber: 'الرقم الوطني الموحد',
    checkCommercialRegistrationNumberError: 'البيانات غير مسجلة بوزارة التجارة',
    unifiedNumberCancelled: 'حالة الرقم الوطني الموحد مشطوب',
    checkManagerSocialIdError: 'هوية المدير ليست موجودة في السجل التجاري',
    prohibitedCommercialTypeForJoinderRequest: 'لا يمكن تقديم طلب ادخال لفرع الشركة',
    prohibitedCommercialType: details => `يُرجى إدخال السجل التجاري الرئيسي لـشركة ${details.name}  ${details.unifiedNumber}.`,

  },
  firmData: {
    title: 'بيانات الشركة',
    name: 'اسم الشركة',
    socialId: 'هوية مدير الشركة',
    activities: 'نشاط الشركة',
    managerTitle: 'بيانات مدير الشركة',
    commercialRegistrationNumberOrUnifiedNumber: 'رقم السجل التجاري/الرقم الوطني الموحد',
    commercialRegistrationNumber: 'رقم السجل التجاري',
    firmManager: 'مدير الشركة',
    unifiedNumber: 'الرقم الوطني الموحد',
    commercialRegistrationTypeName: 'نوع السجل التجارى',
  },
  foreignCompanyData: {
    title: 'بيانات الشركة أو المؤسسة أجنبية',
    name: 'اسم الشركة أو المؤسسة أجنبية',
    managerTitle: 'بيانات مدير الشركة أو المؤسسة أجنبية',
    commercialRegistrationNumber: 'رقم السجل التجاري',
    unifiedNumber: 'الرقم الوطني الموحد',
    managerIdentityType: 'نوع هوية المدير',
    nameIsDifferent: 'الاسم مختلف',
  },
  titleHeader: {
    residenceAddress: 'عنوان الاقامة',
    workAddress: 'عنوان جهة العمل',
    addressCompany: 'عنوان الشركة',
    addressCorporation: 'عنوان المؤسسة',
    addressGovernmental: 'عنوان الجهة الحكومية',
    addressEmbassy: 'عنوان سفارة / قنصلية',
    addressHumanitarian: 'عنوان الهيئة',
    addressFacility: 'عنوان المنشأة',
    addressAssociation: 'عنوان الجمعية',
  },
  facility: {
    title: 'بيانات المنشأة',
    name: 'اسم المنشأة',
    number: 'رقم المنشأة',
  },
  inheritorData: {
    title: 'بيانات الورثة',
    judgementCode: 'رقم صك حصر الورثة',
    mustUseInheritorSocialId: 'يجب إدخال هوية المورث (المتوفى) المسجل في بيانات صك حصر الورثة',
    judgementCodeNotVerified: 'لم ينجح التحقق من رقم صك حصر الورثة',
    invalidNumber: 'رقم الصك غير صحيح',
    heirs: 'بيانات الورثة',
    dead: 'متوفى',
    alive: 'حى',
    name: 'الاسم',
    socialId: 'رقم الهوية',
    relationToDeceasedName: 'صلة القرابة بالمتوفى',
    lifeStatusName: 'حالة الوارث',
    check: 'التحقق من صك الورثة',
    checkInheritorData: 'يرجي الاستعلام عن بيانات الورثة',
    msg1: 'يلزم إضافة كافة الورثة الظاهرة أسمائهم باستثناء الآتي: ',
    msg2: '- إذا تقدم أحد الورثة أو بعضهم بإقراره بتحمل قيمة المطالبة عن بقية الورثة.',
    msg3: '- وجود تعدي أو تفريط من بعض الورثة.',
    msg4: '- في حال تنازل بعض الورثة عن الإرث.',
    msg5: '- إذا كانت الأموال بيد أحد من الورثة.',
    impNote: 'معلومات هامة ',
    inheritorSocialId: 'رقم هوية المورث',
  },
  lawsuitDetails: {
    pledge: {
      title: 'التعهد',
      pledgeLabel:
        'أتعهد بتدوين جميع البيانات بالشكل الصحيح حسب الوثائق الرسمية ، وأقر بأنه لم يسبق لي أن تقدمت بموضوع هذه الدعوى لأي جهة قضائية ، وأن دعواي ليست صورية أو كيدية وأتحمل كامل المسؤولية إذا ثبت خلاف ذلك.',
      pledgeErrorText: 'الرجاء الموافقة على التعهد',
    },
    reason: 'السبب',
    courtSpecialtyType: 'محكمة الإختصاص النوعي',
    isTherePartyPlaceCondition: 'هل يوجد شرط بين الطرفين لتحديد مكان إقامة الدعوى؟ ',
    workCity: 'مقر العمل في القضية المرفوعة',
    specializedLocation: 'الاختصاص المكاني',
    agreedLawsuitCityUponContract: 'مكان إقامة الدعوى المتفق عليه في العقد',
    isOneOfPartiesIsCompany: 'هل أحد أطراف الدعوي شركة والنزاع متعلق بفرع الشركة',
    agreedCourt: 'المدينة المتفق عليها',
    companyBranchAttention: 'تنبيه: تظهر المحكمة التي يقع في نطاق اختصاصها المركز الرئيسي للشركة والمحكمة التي يقع في نطاق اختصاصها فرع الشركة وذلك في المسائل المتعلقة بهذا الفرع بناءً على المادة الثامنة والثلاثون من نظام المرافعات الشرعية',
    governmentBranchAttention: 'تنبيه: تظهر المحكمة التي يقع في نطاق اختصاصها المقر الرئيسي للجهة الحكومية والمحكمة التي يقع في نطاق اختصاصها فرع الجهة وذلك في المسائل المتعلقة بهذا الفرع بناءً على المادة السابعة والثلاثون من نظام المرافعات الشرعية',
    companyBranchCity: 'المدينة التى يقع فيها مقر الشركة',
    governmentBranchCity: 'فرع الجهة الحكومية',
    inspectionCity: 'محل مكان المعاينة',
    workCityDescription: 'القائمة تضم المدن التي يتواجد بها محاكم عمالية أو دوائر عمالية في المحكمة العامة، وفي حال عدم تواجد محكمة أو دائرة في مدينة مقر العمل، يتم اختيار أقرب مدينة للمقر من القائمة',
    executionDescription: 'يجب أن تكون المنازعة في مدينة الطلب التنفيذي مالم تكن الدعوى إعسار  فتقام الدعوى في بلد السجين',
    coronaAttention: 'نظرا لاختيارك أن الدعوى متاثرة بجائحة كورونا سيتم احاله القضية الى محكمة و دائرة مختصة بالنظر بقضايا جائحة كورونا',
    title: 'بيانات موضوع الدعوى',
    court: 'المحكمة',
    caseCategoryTitle: 'تصنيف الدعوى',
    acceptanceCriteria: 'متطلبات الدعوى',
    caseClassification: 'تصنيف الدعوى الرئيسي',
    caseCategory: 'تصنيف الدعوى الفرعي',
    caseSubject: 'موضوع الدعوى',
    caseDemands: 'طلبات المدعي',
    caseProofs: 'أسانيد الطلبات',
    numberOfAttachments: 'المشفوعات',
    caseTypeId: 'نوع الدعوى',
    lawsuitRight: 'الحق',
    criminalCaseNumber: 'الرقم الجنائي',
    operationNumber: 'رقم معاملة الإتصالات الإدارية الخاص بالمحكمة',
    letterNumber: 'رقم الخطاب',
    PreviousProcedures: 'الإجراءات المتخذة',
    witnessStatements: 'أقوال الشهود',
    defendantsStatements: 'أقوال المتهمين',
    mentioned: 'الاتهام',
    requests: 'الطلبات',
    expertsReport: 'تقرير الخبراء',
    facts: 'الوقائع',
    criminalCaseDate: 'تاريخ القضية',
    caseHijriDate: 'تاريخ القضية هجري',
    criminalCaseDescription: 'وصف القضية',
    defendantSocialId: 'هوية المتهم',
    startDate: 'تاريخ بداية الاستجواب',
    interrogationStartHijriDate: 'تاريخ بداية الاستجواب هجري',
    inPresenceOf: 'حضور الاستجواب',
    questionnaire: 'محضر الاستجواب',
    additionalInformation: 'ملاحظات',
    result: 'إجراءات ما بعد الاستجوابات',
    endDate: 'تاريخ نهاية الاستجواب',
    interrogationEndHijriDate: 'تاريخ نهاية الاستجواب هجري',
    prosecutionBranchId: 'معرف فرع النيابة',
    addInterrogation: 'إضافة محضر',
    governmentalOrganizations: 'جهة الورود',
    isAnotherCourtSelected: 'هل تريد إختيار محكمة أخرى لأى سبب ؟',
    anotherCourtSelectedReason: 'اذكر السبب لاختيارك محكمة اخرى',
    HasPreviousRulingBeenIssuedInTheSameClaim: 'هل صدر حكم سابق في محكمة تنفيذ أخرى ؟',
    similarCase: {
      subTitle: 'ربط القضية',
      relatedCases: 'القضايا المرتبطة',
      courtNotFound: 'لم يتم ربط القضية نظراً لاختلاف المحكمة',
      caseNotFound: 'يرجى التحقق من رقم القضية الأصلية',
    },
    criminalRequest: {
      title: 'بيانات الدعوى الجزائية',
      minutesOfInterrogation: 'محاضر الاستجواب',
      criminalSummary: 'ملخص الدعوى الواردة من النيابة',
    },
    trafficRequest: {
      title: 'بيانات الدعوى المرورية',
      trafficAccidentAocation: 'بيانات مكان وقوع الحادث ',
    },
    laborRequest: {
      contract: {
        title: 'بيانات العقد',
        language: 'اللغة',
        number: 'رقم العقد',
        jobTitle: 'المهنة',
        date: 'تاريخ العقد',
        typeId: 'نوع العقد',
        duration: 'مدة العقد (بالسنوات)',
        startDate: 'تاريخ البداية',
        endDate: 'تاريخ النهاية',
        paymentMethod: 'الأجر الأساسي',
        salary: 'قيمة الأجر',
        benefits: 'المميزات و البدلات',
        isStillWorking: 'ما زلت على رأس عملي',
        dropDate: 'تاريخ ترك العمل',
        dropReason: 'سبب ترك العمل',
        dropOtherReason: 'السبب الآخر لترك العمل',
      },
      requests: {
        title: 'الطلبات',
        modalAddTitle: 'إضافة الطلب',
        modalUpdateTitle: 'تعديل الطلب',
        modalViewTitle: 'الطلب',
        mainRequest: 'الطلب الرئيسي',
        subRequest: 'الطلب الفرعي',
        lengthError: 'يرجى إدخال طلب واحد على الأقل',
        mustBeAloneError: 'لا يمكن إضافة هذا الطلب مع طلبات أخرى',
        gridContainsSingleRequest: request => `لا يمكن إضافة طلبات مع طلب ${request}`,
        maxOccurrenceError: max => `لا يمكن إضافة اكثر من ${max} طلبات لهذا الطلب`,
      },
      evidences: {
        title: 'البينات',
        modalAddTitle: 'إضافة البينة',
        modalUpdateTitle: 'تعديل البينة',
        modalViewTitle: 'البينة',
        evidenceType: 'نوع البينة',
        duplicationError: 'لا يمكن تكرار نوع البينة',
      },
    },
    arbitrationRequest: {
      title: 'بيانات طلب حجة الاستحكام',
      tableTitle: 'بيانات القطعة',
      schemaNumber: 'رقم المخطط',
      landNumber: 'رقم القطعة',
      eastPoint: 'الشرقيات',
      northPoint: 'الشماليات',
      addButton: 'إضافة القطعة',
      noData: 'لم تقم بإضافة اي قطعة.',
      action: 'الإجراء',
      argumentPointError: 'يرجى إضافة الشرقيات و الشماليات',
      duplicatedValue: 'لا يمكن تكرار بيانات الشرقيات و الشماليات',
    },
    custodyRequest: {
      title: 'بيانات المطلوب حضانتهم',
      modalTitle: 'إضافة المطلوب حضانته',
      hasMindProblems: 'قاصر عقلاً',
      becomeHasMindProblems: 'طرأ عليه القصور',
      custodyPeopleError: 'يرجى إدخال بيانات المطلوب حضانتهم',
      duplicatedValue: 'لا يمكن تكرار بيانات المطلوب حضانته',
    },
    lawsuitRights: {
      general: 'حق عام',
      private: 'حق خاص',
    },
    terminationsRequest: {
      add: 'إضافة',
      addConcerned: 'إضافة أحد ذوي الشأن بالقاصر ',
      subTitle: 'بيانات ذوي الشأن بالقاصر ',
      title: 'ذوي الشأن بالقاصر',
      promise: 'أتعهد بإضافة كافة الأشخاص الذين لهم الحق في الإشراف على شؤون القاصر أو تمثيله، شريطة أن يكون لهم مصلحة من المولى عليه إما حالاً كالنفقة، أو مآلاً كالإرث.',
      tooltipHeader: 'ذوو الشأن هم :',
      tooltip: ' الأشخاص الذين لهم الحق في الإشراف على شؤون القاصر أو تمثيله، شريطة أن يكون لهم مصلحة من المولى عليه إما حالاً كالنفقة، أو مآلاً كالإرث.',
    },
    isRelatedToCorona: 'هل الدعوى أو طلباتك تأثرت بجائحة كورونا؟',
    relatedToCoronaReasons: 'السبب والأسانيد',
    notes: 'الوصف',
    alert: ' التلميحات',
    exceptions: 'الاستثناءات',
    lawsuitFeesNote: 'عزيزي المستفيد، يمكنكم التحقق من شمول الدعوى للتكاليف القضائية، عبر الرابط',
    caseRelatedRequestPledge: 'أتعهد بتدوين جميع البيانات بالشكل الصحيح حسب الوثائق الرسمية وأتحمل كامل المسؤولية إذا ثبت خلاف ذلك',
    caseRelatedRequestFeesNote: 'عزيزي المستفيد، يمكنكم التحقق من شمول الطلب للتكاليف القضائية، عبر الرابط',
    navigateToOldPortal: 'عزيزي المستفيد، يمكن العودة الي النسخة السابقة من خلال',
    smartOptionNoteHead: 'المساعد الذكى لاختيار صحيفة الدعوى',
    smartOptionNoteContent: 'سعياً لتحسين التجربة القضائية, أجب عن مجموعة الاسئلة الظاهرة امامك ليقوم النظام بإقتراح التصنيف المناسب لصحيفة الدعوى الخاصة بك',
    selectCaseType: 'اختيار نوع الدعوى',
    smartOptionTxt: 'هل ترغب في مساعدتك لاختيار تصنيف الدعوى بشكل صحيح؟',
    noHelp: 'لا ارغب بالمساعدة',
  },
  lawsuitValidations: {
    currentUserShouldExists: name => `عفواً، يجب إضافة ${name ? name : 'صاحب الحساب'} كأحد أطراف الدعوى`,
    currentRepresentativeShouldExists: (repName, firmName) => `عفواً، يجب اضافة بياناتك الشخصية كممثل عن ${firmName ? firmName : 'حساب الجهة'}`,
    shouldAddProsecutor: 'يجب إضافة مدعي',
    shouldAddDefendant: 'يجب إضافة مدعى عليه',
    moreOne: 'آخر غير المورث (المتوفى)',
    shouldAddRepresentative: name => `يجب إضافة ممثل عن ${name}`,
    defendantShouldEnterMobile: name => `يجب إضافة الهاتف الجوال للمدعى عليه ${name}`,
    casePartyInvalidNationality: name => `عفواً، يجب تحديد جنسية ${name ? name : 'المدعين الأفراد'}`,
    casePartyInvalidSocialIdType: name => `عفواً، يجب تحديد نوع هوية ${name ? name : 'الأطراف من نوع فرد'}`,
    errorWhileLoadingData: `عفواً، حدث خطأ أثناء تحميل البيانات سيتم إعادة التحميل تلقائياً و يمكنك استكمال الخطوات`,
    lawyerShouldBeAdded: 'عفواً، يجب أن تكون محامي أو محامي متدرب لأحد المدعين لإستكمال الطلب',
    lawyerShouldNotBeAdded: 'هذا الشخص محامي يجب التوجه لحساب ناجز محامين لتقديم الدعوى ',
    shouldChooseApplicant: 'يجب تحديد مقدم الطلب',
    cantRemoveProsecutor: 'لا يمكن حذف المدعي',
    cantRemoveDefendant: 'لا يمكن حذف المدعى عليه',
    cantAddDeadPersons: 'لا يمكن إضافة هوية متوفى ضمن أطراف الدعوى',
    cantAddAlivePersons: 'لا يمكن إضافه هوية غير متوفي ضمن أطراف الدعوى',
    cantRemoveRepresentative: 'لا يمكن حذف الممثل',
    isProsecutorCasePartyExists: 'هذا المدعى مسجل مسبقاً ولا يمكن تكراره',
    isCasePartyExistsAsDefendantOrRepresentative: 'هذا الشخص مسجل ضمن قائمة المدعى عليهم أو من يمثلهم ولا يمكن إضافته',
    isDefendantCasePartyExists: 'هذا المدعى عليه مسجل مسبقاً ولا يمكن تكراره',
    isCasePartyExistsAsProsecutorOrRepresentative: 'هذا الشخص مسجل ضمن قائمة المدعين أو من يمثلهم ولا يمكن إضافته',
    cannotAddCurrentUserAsDefendant: 'عفواً، لا يمكن إضافتك كمدعى عليه أو ممثل للمدعى عليه',
    cannotAddCurrentUserAsInheritor: 'عفواً، لا يمكن إضافتك كمورث (متوفى)',
    cannotAddCurrentUserAsOrganizationFromNajizOrg: 'عفواً، وفقاً للرقم الوطني الموحد المدخل يجب ان تتم إضافة الطرف من نوع شركة',
    isCasePartyRepresentativeExists: 'هذا الممثل مسجل لنفس طرف الدعوى ولا يمكن إضافته',
    isProsecutorCasePartyExistsForTheSame: 'هذا المدعى مسجل مسبقاً ولا يمكن تكراره',
    isCasePartyExists: 'هذا الشخص مسجل مسبقاً ولا بمكن تكراره',
    removeCurrentUser: 'عفواً،لا يمكن حذف بياناتك من الدعوى -يجب إضافة اسمك كمدعي أو ممثل للمدعي',
    removeCasePartyRelatedToCurrentUser: 'لا يمكن حذف موكلك من الدعوى',
    preventAddingDefendantTerminationLawsuit: 'عفوا، الإنهاءات لا تتطلب إضافة مدعى عليه',
    missingAttachmentType: 'عفوا، الرجاء إرفاق',
    defendantShouldBeRetrievedFromMoi: name => `يجب التحقق من بيانات المدعى عليه من وزارة الداخلية ${name}`,
    preventSaveWithoutRepresentative: 'عفواً، يجب ان يضاف ممثل للطرف الاصغر من ١٨ عاماً',
    shouldAddLiquidatorRepresentative: 'يجب إضافة المصفي',
    shouldAddJudicialGuardRepresentative: 'يجب إضافة الحارس القضائي',
    applicantMustBeRepresentative: 'يرجى توكيل مقدم الطلب لاستكمال تقديم الطلب بنجاح',
    canntAddyouAsLawyer: 'لا يمكن إضافتك كمحامي لأحد المدعيين الرجاء التوجه الى ناجز محامين لتقديم الدعوى',
  },
  lawsuitReport: {
    errorTitle: 'فشل تحميل الدعوى',
    errorDetails: 'حدث خطأ أثناء تحميل بيانات الدعوى من فضلك حاول مرة أخري أو ارجع الي الدعم الفني',
    detailsText: 'بيانات',
    personDetails: 'البيانات الشخصية',
    commercialRegisterNo: 'رقم السجل التجاري',
    nationality: 'الجنسية',
    gender: 'النوع',
    isPrisoner: 'هل هو سجين؟',
    socialIDType: 'نوع الهوية',
    socialID: 'رقم الهوية',
    profession: 'المهنة',
    workTypeName: 'نوع جهة العمل',
    workingPlaceName: 'اسم جهة العمل',
    workFor: 'جهة العمل',
    address: 'عنوان الإقامة',
    workAddress: 'عنوان العمل',
    countryName: 'الدولة',
    regionName: 'المنطقة',
    cityName: 'المحافظة',
    districtName: 'الحي',
    streetName: 'الشارع',
    buildingNo: 'رقم العقار',
    phones: 'الهواتف',
    mobile: 'الجوال',
    workPhone: 'هاتف العمل',
    fax: 'الفاكس',
    postAddress: 'العنوان البريدي',
    postAddressCityName: 'المدينة',
    postAddressDistrict: 'الحى',
    postAddressStreetName: 'الشارع',
    postAddressBuildingNo: 'رقم المبنى',
    postAddressFlatNo: 'رقم الوحدة',
    postAddressCode: 'الرمز البريدي',
    postAddressExtraCode: ' الرقم الإضافي',
    caseDetails: 'بيانات الدعوى',
    caseDemand: 'طلبات المدعي',
    caseProof: 'اسانيد الدعوى',
    caseSubject: 'الموضوع',
    caseType: 'تصنيف الدعوى',
    courtName: 'المحكمة',
    requestPersonName: 'مقدم الطلب أو ممثله',
  },
  casePartyCard: {
    judgmentCode: 'رقم الحكم',
    courtName: 'اسم المحكمة',
    deedNumber: 'رقم صك التوثيق',
    issuer: 'جهة الإصدار',
    other: 'أخري',
    applicant: 'مقدم الطلب',
    nationality: 'الجنسية',
    city: 'المدينة',
    mobile: 'الجوال',
    birthHijri: 'تاريخ الميلاد هجري',
    prisoner: 'سجين',
    update: 'تعديل',
    remove: 'حذف',
    cessationSupervisor: 'ناظر الوقف',

  },
  liquidatorOrJudicialGuardForms: {
    title: 'بيانات التصفية',
    sharedAssetType: 'النوع',
    sharedAssetName: 'اسم المال المشترك',
    sharedAssetTypeTooltipContent: 'المال المشترك: هو المال المملوك لاثنين فأكثر على الشيوع<br>التركة: ما تركه الشخص بعد موته من مال أو حق',
  },
  cessationForm: {
    name: 'اسم الوقف',
    cessationType: 'نوع مستند الوقفية',
    cessationSupervisorType: 'نوع مستند النظارة على الوقف',
    judgmentNumber: 'رقم الحكم',
    courts: 'المحكمة التي اصدرت الحكم',
    deedNumber: 'رقم صك التوثيق',
    issuer: 'جهة الإصدار',
    other: 'أخرى',
    courtSubCircles: 'الدائرة التي أصدرت الحكم',
    deedDate: 'تاريخ صك التوثيق',
    tittle: 'بيانات الوقف',
    supervisorTittle: 'مستند النظارة',
    selectType: 'نوع الوقف',
    cessationSupervisor: 'ناظر الوقف',

  },
  externalInquiries: {
    najizCases: 'قضايا ناجز',
    oracleCasesTitle: 'النظام الشامل',
    terminationCasesTitle: 'نظام الإنهاءات',
    reconciliationRequestsTitle: 'طلبات الصلح',
    caseDate: 'تاريخ القضية',
    requestDate: 'تاريخ الطلب',
    caseCode: 'رقم القضية',
    requestNumber: 'رقم الطلب',
    caseStatusDesc: 'حالة القضية',
    requestStatusDesc: 'حالة الطلب',
    categoryDescription: 'تفاصيل القضية',
    courtName: 'اسم المحكمة',
    caseType: 'نوع القضية',
    personName: 'الاسم',
    prosecutorName: 'اسم المدعي',
    defendantName: 'اسم المدعى عليه',
    personStatusDesc: 'الحالة',
    firstName: 'الاسم الأول',
    fatherName: 'اسم الأب',
    gfName: 'اسم الجد',
    familyName: 'اسم العائلة',
    terminationCode: 'رقم الإنهاء',
    terminationDate: 'تاريخ الإنهاء',
    terminationTypeName: 'نوع الإنهاء',
    fullName: 'الاسم بالكامل',
  },
  partyTypeSelection: {
    type: 'النوع',
    reference: 'الصفة',
    isInheritor: 'إضافة بصفة مورث (متوفى)',
    isInheritor1: 'هل المطالبة متعلقة بمتوفى؟',
    isOrganizationOwner: 'إضافة فرد بصفة (مالك مؤسسة)',
  },
  representative: {
    letterDate: 'تاريخ الخطاب',
    letterSourceId: 'مصدر الخطاب',
    letterNumber: 'رقم الخطاب',
  },
  userMenuLinks: {
    changePassword: 'تغيير كلمة المرور',
    userGuide: 'دليل المستخدم',
    logOut: 'تسجيل الخروج',
  },
  attachments: {
    title: 'المرفقات',
    add: `إضافة`,
    addToRequest: 'إضافة للطلب',
    addAttachment: `إضافة مرفق`,
    attachment: 'المرفق',
    attachmentName: `اسم المرفق`,
    attachmentType: `نوع المرفق`,
    sampleImage: 'صورة توضيحية',
    description: 'الوصف',
    acceptanceCriteria: 'اشتراطات قبول المرفق',
    attachmentsAudited: 'تم التأكد من صحة المرفق',
    errors: {
      thisFileUploadedBefore: `لقد تم إضافة هذا الملف مسبقاً`,
      name: `يجب إدخال اسم المرفق`,
      nameNotUnique: 'يوجد مرفق بنفس الاسم',
      category: `يجب اختيار نوع المرفق`,
      attachment: `يجب اختيار مرفق`,
      sizeExceeded: size => `أقصى حد مسموح لحجم الملف هو ${size} ميجابايت`,
      acceptedMediaTypes: 'pdf نوع المرفق يجب أن يكون صورة أو ملف',
    },
  },
  previousReplies: {
    title: 'سجل الطلب',
    colUserFullName: 'المستخدم',
    colHijiriReplyDate: 'التاريخ',
    colHijiriReplyDateTime: 'التاريخ و الوقت',
    colReplyType: 'الإجراء',
    colDataExpand: 'التفاصيل',
  },
  requestReply: {
    movementType: 'نوع الإحالة',
    reply: 'الرد',
    requestReplyButtonText: 'الرد على الطلب',
    addReason: 'إضافة سبب',
    reasons: 'الأسباب',
    number: 'عدد القضايا',
    date: 'تاريخ',
    selectSubCircle: 'اختر الدائره',
    unknownAddress: 'مجهول العنوان',
    moveRequestWithoutDate: 'سوف يتم الإحاله بدون موعد',
    chargePartyTitle: 'المكلف بالسداد',
    informPartyTitle: 'المكلف بالتبليغ',
    informMethod: 'طريقة التبليغ',
    backToCasesSearch: 'العودة إلى الطلبات',
    sendSuccessfully: 'تم إرسال الطلب بنجاح',
    moveRequestDone: 'تم إحالة الطلب إلى قسم الصلح بنجاح',
    moveRequestToReconciliationPlatformSuccess: 'تم إحالة الطلب إلى منصة تراضي بنجاح',
    requestNumberIs: 'رقم طلب الصلح هو',
    caseNumberIs: 'رقم القضية هو',
    requestMovedTo: 'تم إحالة الطلب إلى',
    withSuccess: 'بنجاح',
    printLawsuitRequest: 'طباعة صحيفة الدعوى',
    printMovementTicket: 'طباعة تذكرة الإحالة',
    caseParties: 'آلية التبليغ',
    check: 'تحقق',
    checkSocialAddress: 'التحقق من العنوان الوطنى',
    checkAddressError: 'ليس لديه عنوان',
    writeReason: 'اكتب سبب',
    writeNote: 'كتابة ملاحظة',
    checklist: {
      title: 'تم التأكد من صحة واكتمال',
      validateCourt: 'تم التأكد من صحة اختيار المحكمة المختصة',
      validateCaseClassification: 'تم التأكد من تصنيف الدعوى الرئيسي',
      validateCaseCategory: 'تم التأكد من تصنيف الدعوى الفرعي',
      validateCaseType: 'تم التأكد من صحة نوع الدعوى',
    },
    confirmationTitle: 'تأكيد الحفظ',
    confirmationMessage: 'هل تريد تأكيد حفظ مذكرة الدفاع الأولى',
    sendRequestToCourt: 'إرسال الطلب',
    cancelRequest: 'إلغاء الطلب',
    sendRequestConfirmationMessage: 'هل أنت متأكد من إرسال الطلب؟',
    sendRequestSimilarRequestsConfirmationMessage: 'يوجد طلب سابق مشابه لهذا الطلب، هل أنت متأكد من إرسال الطلب؟',
    updateRequestConfirmationMessage: 'هل أنت متأكد من تحديث الطلب؟',
  },
  errors: {
    somethingWentWrong: 'حدث خطأ ما',
    wentWrongWhile: name => `حدث خطأ أثناء جلب ${name}`,
  },
  print: { title: 'بسم الله الرحمن الرحيم' },
  appointmentTicket: {
    signature: 'رئيس',
    country: 'المملكة العربية السعودية',
    ministry: 'وزارة العدل',
    title: 'تذكرة إحالة',
    caseParties: 'أطراف الدعوى',
    operationNumber: 'رقم القيد',
    caseCode: 'رقم القضية',
    caseDate: 'تاريخ القضية',
    caseTypeName: 'نوع الدعوى',
    prosecutorName: 'المدعي',
    defendantName: 'المدعى عليه',
    appointment: 'موعد نظر القضية',
    appointmentStartDate: 'التاريخ',
    appointmentStartDay: 'اليوم',
    appointmentStartTime: 'الوقت',
    address: 'العنوان',
    distributedBy: 'اسم الموظف',
    distributionType: 'نوع الإحالة',
    distributionDate: 'وقت الإحالة',
  },
  lawsuitPaper: {
    title: 'صحيفة الدعوى',
    signature: 'التوقيع',
    requestNumber: 'رقم الطلب',
    requestDate: 'تاريخ الطلب',
    personalDetails: 'البيانات الشخصية',
    employerDetails: 'بيانات جهة العمل',
    addressDetails: 'بيانات محل الإقامة',
    phones: 'الهواتف',
    prosecutorName: 'بيانات المدعي',
    defendantName: 'بيانات المدعى عليه',
    caseDetails: 'بيانات الدعوى',
    name: 'الاسم',
    gender: 'النوع',
    nationality: 'الجنسية',
    isJailed: 'هل هو سجين؟',
    proofType: 'نوع الإثبات',
    proofNumber: 'رقم الإثبات',
    jobTitle: 'المهنة',
    employerType: 'نوع جهة العمل',
    employerName: 'اسم جهة العمل',
    country: 'الدولة',
    district: 'المنطقة',
    city: 'المحافظة',
    neighborhood: 'الحي',
    street: 'الشارع',
    buildingNumber: 'رقم العقار',
    mobileNumber: 'الجوال',
    workNumber: 'هاتف العمل',
    fax: 'الفاكس',
    caseCategory: 'تصنيف الدعوى',
    caseSubject: 'الموضوع',
    court: 'المحكة',
    prosecutorRequests: 'طلبات المدعي',
    caseProve: 'أسانيد الدعوى',
    applicant: 'مقدم الطلب أو ممثله',
    attachments: 'المرفقات',
  },
  redistribution: {
    allowToAll: 'إتاحه للكل',
    modalTitle: 'إعادة توزيع',
    selectEmployee: 'اختر الموظف',
    successMessage: 'تم إعادة توزيع الطلبات بنجاح',
    redistributionLawsuitRequestsTo: 'إعادة توزيع طلبات صحائف الدعوى على',
  },
  executionRequest: {
    title: 'بيانات طلبات التنفيذ',
    identityType: 'نوع هوية المنفذ ضده',
    identityId: 'رقم هوية المنفذ ضده',
    requestCodes: 'الطلبات',
    verify: 'تحقق',
    code: 'رقم الطلب',
    documentTypeName: 'نوع الوثيقة',
    submittedDate: 'تاريخ التقديم',
    courtName: 'اسم المحكمة',
    requestStatusName: 'الحالة',
  },
  changeAuditPath: {
    allowToAll: 'إتاحه للكل',
    modalTitle: 'تغيير مسار',
    selectEmployee: 'اختر المسار',
    successMessage: 'تم تغيير مسار الطلبات بنجاح',
  },
  relatedCases: {
    title: 'القضايا المرتبطة',
    unlink: 'إلغاء الإرتباط',
    tableActionButton: 'عرض القضايا المتشابهة',
  },
  similarCases: {
    title: 'القضايا المتشابهة',
    addRelatedCase: 'القضايا وطلبات الصلح المرتبطه',
    linkCase: 'ربط القضية',
  },
  similarReconciliationRequests: { title: 'طلبات الصلح' },
  breadcrumbs: {
    judgement: 'القضاء',
    home: 'الصفحة الرئيسية',
    homeNew: 'الصفحة الرئيسية',
    lawsuitRequests: 'طلب صحيفة الدعوى',
    externalInquiries: 'الاستعلام العام عن القضايا برقم الهوية',
    canceledCaseReply: 'رد المحكمة العليا على قضية مشطوبة',
    caseJudgmentsReply: 'رد المحكمة العليا/الإستئناف على الأحكام',
    caseRelatedRequest: 'الطلبات على القضايا',
    caseRelatedProcedure: 'الإجراءات على القضايا',
    sessions: 'الجلسات',
    caseFile: 'ملف القضية',
    caseSpecificRequests: 'الطلبات الاستثنائية',
    judicialFees: 'التكاليف القضائية',
    replyToLawsuit: 'مذكرة الدفاع الأولى',
    bankruptcy: 'الإفلاس',
    bankruptcyRequests: 'طلبات الإفلاس',
    bankruptcyRequest: 'طلب فتح إجراء إفلاس',
    bankruptcySubRequests: 'طلباتي',
    caseDigitalizationRequest: 'طلب تحديث بيانات القضية',
    replyMemo: 'مذكرة الجواب',
    reconsiderationFromNonCaseParty: 'طلب التماس إعادة نظر',
    myRequests: 'طلباتى',
    incomingRequests: 'الطلبات الواردة',
    petitionRequests: 'طلب الالتماس',
    waiverRequest: 'طلب تنازل',
  },

  caseReply: {
    tableHeader: {
      caseCode: 'رقم القضية',
      caseDate: 'تاريخ القضية',
      court: 'المحكمة',
      circle: 'الدائرة',
      caseStatusName: 'حالة القضية',
      caseCategoryName: 'تصنيف القضية',
      caseType: 'نوع القضية',
      judgementCode: 'رقم الحكم',
    },
    filters: {
      caseCode: 'رقم القضية',
      year: 'العام',
      judgmentCode: 'رقم الحكم',
    },
    replyForm: {
      title: 'رد المحكمة العليا',
      caseFromCourt: 'القضية واردة من محكمة',
      replyType: 'نوع الرد',
      transactionNumber: 'رقم المعاملة',
      scan: {
        title: 'إضغط هنا لإضافة مرفق',
        description: 'إضغط هنا لاختيار صورة ورفعها',
      },
      notes: 'ملاحظات',
      moveToCircle: 'إحالة إلي الدائرة',
      caseComesFrom: 'القضية واردة من',
      judgmentCode: 'رقم الحكم',
      errors: {
        allCheckListCheckedAndNotComplete:
          'لا يمكنك الرد على الطلب بأنه غير مكتمل في حالة التأشير على كل الخيارات بأنها صحيحة ومكتملة',
        notAllCheckListCheckedAndAcceptedFromAudit:
          'لا يمكنك الإرسال إلى صحائف الدعوى في حالة عدم التأشير على كل الخيارات بأنها صحيحة ومكتملة',
        notAllCheckListCheckedAndTransferToRandomSubCircle:
          'لا يمكنك الإحالة إلى الدوائر القضائية في حالة عدم التأشير على كل الخيارات بأنها صحيحة ومكتملة',
        notAllCheckListCheckedAndRegister:
          'لا يمكنك قيد الطلب في حالة عدم التأشير على كل الخيارات بأنها صحيحة ومكتملة',
        notAllCheckListCheckedAndTransferToReconciliation:
          'لا يمكنك الإحالة إلى قسم الصلح في حالة عدم التأشير على كل الخيارات بأنها صحيحة ومكتملة',
        notAllCheckListCheckedAndTransferToReconciliationPlatform:
          'لا يمكنك الإحالة إلى منصة تراضي في حالة عدم التأشير على كل الخيارات بأنها صحيحة ومكتملة',
      },
    },
    errorWhileReteriveData: 'حدث خطأ اثناء جلب البيانات',
    caseNotFound: 'بيانات القضية غير موجودة',
    cancelReasons: 'إلغاء صحيفة دعوى-مقدم الطلب',
  },
  caseRelatedRequest: {
    sendRequestReplyConfirmationMessage: 'هل أنت متأكد من إرسال الرد على الطلب ؟',
    requestReplySentSuccessfully: 'تم إرسال الرد على الطلب بنجاح',
    filters: {
      caseCode: 'رقم القضية',
      year: 'العام',
      court: 'المحكمة',
      partyType: 'نوع طرف الدعوى',
      socialTypeId: 'نوع الهوية',
      socialId: 'رقم الهوية',
      commercialRegistrationNumber: 'السجل التجاري',
      firmName: 'اسم المؤسسة',
      organizationName: 'اسم الشركة',
      foreignCompanyName: 'اسم الشركة أو المؤسسة أجنبية',
      embassyName: 'اسم جهة السفارة / القنصلية',
      governmentAgencyName: 'اسم الجهة الحكومية',
      associationName: 'اسم الجمعية',
      humanSocietyName: 'اسم جهة الهيئة دولية / إنسانية',
      judgementCode: 'رقم الحكم',
      identityNumber: 'رقم هوية احد الأطراف',
    },
    case: {
      caseCode: 'رقم القضية',
      caseDate: 'تاريخ القضية',
      caseTypeName: 'نوع الدعوى',
      caseStatusName: 'حالة القضية',
      caseCategoryName: 'تصنيف الدعوى',
      courtName: 'المحكمة',
      subCircleName: 'الدائرة',
      casePartyName: 'اسم طرف الدعوى',
    },
    request: { title: 'بيانات الطلب' },
    notFound: 'عفواً البيانات المدخلة غير صحيحة يرجى التحقق من البيانات.',
    errors: {
      reasonsNumberError: 'يجب إضافة سبب واحد على الاقل.',
      attorneyAttachmentNotFound: 'يجب إرفاق صورة الوكالة',
      judgementAttachmentNotFound: 'يجب إرفاق صورة صك الحكم',
      letterImageAttachmentNotFound: 'يجب إرفاق صورة الخطاب',
    },
    addRepresentative: {
      fullExplanation: 'خدمة تتيح للمستفيدين من إضافة ممثل نظامي الى قضية معينة وذلك بالبحث عن القضية برقم القضية والمحكمة والعام ثم يتم تعبئية بيانات الممثل وبيانات الوكالة  و أسباب الطلب والمرفقات ويتم التحقق من النظام اذا كان رقم الوكالة صحيح',
      shortExplanation: 'خدمة تتيح للمستفيدين من إضافة ممثل نظامي الى قضية معينة',
    },
    legacyCaseDigitalizationRequest: {
      fullExplanation: 'خدمة تتيح للمستفيدين  تحديث بيانات القضايا الورقية لتمكينهم من الاطلاع على بيانات القضية من خلال بوابة ناجز وذلك بتعبئة البيانات الشخصية وتفاصبل القضية',
      shortExplanation: 'خدمة تتيح للمستفيدين  لتحديث بيانات القضايا الورقية لتمكينهم من الاطلاع على بيانات القضية من خلال بوابة ناجز وذلك بتعبئة البيانات',
    },
    IntervenorRequest: {
      casePartyRole: 'الصفة',
      fullExplanation: 'خدمة تتيح للمستفيدين من التدخل في قضية معينة وذلك بالبحث عن القضية برقم القضية والمحكمة والعام ثم يتم تعبئية بيانات الطرف المتدخل وإدخال أسباب التدخل والمرفقات.في  حالة قبول الطلب من الدائرة القضائية سيتم إضافة الطرف المتدخل الى الطراف الدعوى.',
      shortExplanation: 'خدمة تتيح للمستفيدين من التدخل في قضية معينة وذلك بالبحث عن القضية أولا',
    },
    requestForm: 'نموذج الطلب',
    requestReasons: 'أسباب الطلب',
    requestReasonsWarning: 'عدد الأسباب المسموح فيها 5 كحد اقصى',
    startService: 'ابدأ الخدمة',
    judgement: 'القضاء',
    VerdictObjectionRequest: {
      title: 'طلب الاعتراض على حكم',
      partyName: 'طرف الدعوى',
      judgementCode: 'رقم الحكم',
      displayJudgement: 'عرض الحكم',
      noJudgementFile: 'لا يوجد ملف حكم',
      appealType: 'نوع طلب الاستئناف',
      objectionJudgment: 'الحكم المعترض عليه',
      memorandumChallenge: 'نص مذكرة الاعتراض على الحكم',
      memorandumChallengeAlert: 'لا يتم النظر لاي طلب لم يذكر فيه نص مذكرة الإعتراض',
      attachmentNote: 'لن يتم النظر إلى أي لوائح اعتراضية في المرفق،  والمرفق مخصص فقط للمستندات الداعمة',
      objectionJudgmentConfirmText: 'بناءً على لائحة نظام المرافعات الشرعية رقم 1 / 188 يجب على مقدم الطلب إرفاق مذكرة الإعتراض موقع عليها في كل ورقه من ورقاتها',
      addObjectionNoteAttachment: 'المرفقات الداعمة للاعتراض',
      objectionNoteAttachment: 'المرفقات الداعمة للاعتراض',
      removeObjectionNoteAttachmentMessage: 'لا يمكن استرجاع مرفق مذكرة إعتراض بعد الحذف. هل ترغب بتأكيد الحذف؟',
      judgmentNotAvailableForObjectionErrorMsg: 'لا يمكن اختيار الحكم لانتهاء المدة الاعتراضية',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب لائحة اعتراضية على حكم صادر من محاكم الدرجة الأولى ويجب أن يكون حالة الحكم "غير قطعي "يمكن تقديم طلب اعتراض على الحكم خلال المدة الاعتراضية للحكم.المدة الاعتراضية للحكم هي 30 يوم للحكم المنهي للخصومة و 10 ايام للحكم العاجل وتبداء المدة من تاريخ تسليم الحكم، ويمكن للمستفيد التعديل على الطلب خلال المدة الاعتراضية وسيتم إحالة الطلب الى الدائرة القضائية بعد انتهاء المدة الاعتراضية',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب لائحة اعتراضية على حكم صادر من محاكم الدرجة الأولى',
      clickHere: ' اضغط هنا ',
    },
    ReconsiderationRequest: {
      title: 'طلب التماس إعادة نظر',
      partyName: 'طرف الدعوى',
      judgementCode: 'رقم الحكم',
      displayJudgement: 'عرض الحكم',
      noJudgementFile: 'لا يوجد ملف حكم',
      judgmentNotAvailableErrorMsg: 'لا يمكن اختيار الحكم، يجب أن يكون الحكم نهائي',
      noticeDate: 'تاريخ العلم بالسبب',
      noticeDateText: '* يجب أن يكون تاريخ العلم بالأسباب خلال 30 يوم من تاريخ اليوم',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب التماس إعادة النظر على جميع الاحكام النهائية أو الاحكام الملتمس عليها سواء كانت الاحكام صادرة من الدرجة الأولى أو من الاستئناف. ويجب أن يتضمن طلب الالتماس على رقم الحكم الملتمس عليه وتاريخ العلم بالأسباب',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب التماس إعادة النظر على جميع الاحكام النهائية',
      stopExecution: 'عزيزي المستفيد هل تريد وقف التنفيذ؟',
      stopExecutionTitle: 'وقف التنفيذ',
      stopExecutionReason: 'اذكر سبب وقف التنفيذ',
      stopExecutionReasonPlaceHolder: 'اذكر سبب وقف التنفيذ',
    },
    JoinderRequest: {
      title: 'طلب إدخال',
      partyName: 'طرف الدعوى',
      casePartyRole: 'الصفة',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب إدخال، وإضافة طرف اخر الى اطراف الدعوى في القضية بعد موافقة الدائرة القضائيةو، ويمكن تقديم الطلب من قبل المدعي أو المدعى عليه',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب إدخال، وإضافة طرف اخر الى اطراف الدعوى في القضية',
    },
    DismissedCaseRequest: {
      title: 'اعادة النظر فى قضية مشطوبة',
      partyName: 'طرف الدعوى',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقيدم طلب إعادة النظر في قضية مشطوبة من خلال المدعي أو من يمثله فقط خلال 60 يوم من شطب القضية اذا كانت حالة القضية مشطوبة',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقيدم طلب إعادة النظر في قضية مشطوبة',
    },
    litigationAbandonmentsRequest: {
      title: 'طلب ترك الخصومة',
      defendantName: 'تحديد المدعى عليه',
      fullExplanation: 'خدمة تتيح للمدعي من التنازل عن القضية أو عن بعض المدعى عليهم قبل موعد الجلسة الاولى ب 24 ساعة',
      shortExplanation: 'خدمة تتيح للمدعي من التنازل عن القضية أو عن بعض المدعى عليهم قبل موعد الجلسة الاولى ب 24 ساعة',
      accept: 'قبول',
      refuse: 'رفض',
      otherPartiesResponse: 'ردود الأطراف المراد التنازل عن خصومتهم',
      requestTemplate: 'نموذج الطلب',
      defendantResponseMessage: 'للرد على طلب ترك الخصومة المقدم من المدعي يرجى الاختيار :',
      defendant: 'المدعى عليه',
      defendantResponse: 'رد المدعى عليه على الطلب',
      defendantResponseDate: 'تاريخ الرد',
      sendResponse: 'تقديم',
      onBehalfOf: 'بالنيابة عن',
    },
    stopResumeLawsuitRequest: {
      title: 'طلب وقف/استمرار السير في الدعوى',
      partyName: 'طرف الدعوى',
      subRequestType: 'نوع الطلب',
      stopDurationName: 'المدة المطلوبة',
      warningMessage: 'سيتم بدء احتساب المدة المطلوبة لوقف السير في الدعوى بعد موافقة المحكمة',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب استمرار السير في الدعوى اذا كانت القضية موقفة بطلب احد الأطراف, و تقديم طلب وقف السير في الدعوى اذا كانت القضية قيد النظر, ويكون وقف السير في الدعوى من 1 شهر الى 6 اشهر وبعد قبول الطلب ستتغير حالة القضية الى موقوفة بطلب احد الأطراف',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب وقف/استمرار السير في الدعوى',
    },
    travelPreventionRequest: {
      title: 'طلب منع من السفر',
      defendantName: 'المدعى عليه المطلوب منعه من السفر',
      requestApplicantTypeMessage: 'يمكن تقديم الطلب من قبل المدعي ومن يمثله فقط',
      fullExplanation: 'خدمة تتيح للمدعي أو من يمثله من تقديم طلب منع من السفر على المدعى عليه اذا كانت القضية قيد النظر',
      shortExplanation: 'خدمة تتيح للمدعي أو من يمثله من تقديم طلب منع من السفر على المدعى عليه',
    },
    liftTravelPreventionRequest: {
      title: 'طلب رفع منع من السفر',
      defendantName: 'المدعى عليه المطلوب رفع منعه من السفر (من عليهم قرار منع فقط)',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب رفع منع من السفر من قبل المدعي أو المدعى عليه اذا وجد قرار معتمد يمنع المستفيد من السفر',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب رفع منع من السفر اذا وجد قرار معتمد يمنع المستفيد من السفر',
      travelPreventionDecisionNumber: 'رقم قرار المنع من السفر',
    },
    removeAgentFromCaseRequest: {
      title: 'طلب حذف القضية من حساب الممثل',
      partyName: 'إختر طرف الدعوى المطلوب حذف الممثل عنه',
      agentToDrop: 'إختر الممثل المراد حذفه',
      chooseApplicantToShowAgentMessage: 'يرجى اختيار مقدم الطلب ، لعرض الممثلين له ، ثم تحديد الممثل المراد حذفه',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب حذف القضية من حساب الممثل ويمكن للممثل حذف نفسه من القضية. سيقوم النظام تلقائيا بحذف الممثل من اطراف الدعوى في القضية',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب حذف القضية من حساب الممثل ويمكن للممثل حذف نفسه من القضية',
    },
    fundsHoldRequest: {
      title: 'طلب الحجز التحفظي على الأموال',
      defendantName: 'المدعى عليه المطلوب الحجز التحفظي على أمواله',
      requestApplicantTypeMessage: 'يمكن تقديم الطلب من قبل المدعي ومن يمثله فقط',
      fullExplanation: 'خدمة تتيح للمدعي أو من يمثله من تقديم طلب حجز تحفظي على اموال المدعى عليه اذا كانت القضية قيد النظر ',
      shortExplanation: 'خدمة تتيح للمدعي أو من يمثله من تقديم طلب حجز تحفظي على اموال المدعى عليه',
    },
    stopFundsHoldRequest: {
      title: 'طلب رفع الحجز التحفظي',
      defendantName: 'المدعى عليه المطلوب وقف الحجز التحفظي على أمواله (من عليهم قرار حجز تحفظي معتمد فقط)',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب رفع الحجز التحفظي من قبل المدعي أو المدعى عليه اذا وجد قرار معتمد بالحجز التحفظي',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب رفع الحجز التحفظي من قبل المدعي أو المدعى عليه اذا وجد قرار معتمد بالحجز التحفظي.',
      decisionNumber: 'رقم قرار الحجز التحفظي',
    },
    correctionOrInterpretationOfJudgmentRequest: {
      title: 'طلب تصحيح الحكم أو تفسيره',
      partyName: 'طرف الدعوى',
      subRequestType: 'نوع الطلب',
      judgementCode: 'رقم الحكم',
      noJudgementFile: 'لا يوجد ملف حكم',
      judgmentNotAvailableErrorMsg: 'لا يمكن اختيار الحكم، يجب أن يكون الحكم نهائي أو غير قطعى',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب تصحيح الحكم أو تفسيره على الاحكام النهائية أو الاحكام الغير قطعية سواء كانت الاحكام صادرة من الدرجة الأولى أو من الاستئناف',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب تصحيح الحكم أو تفسيره على الاحكام',
    },
    cassationRequest: {
      title: 'طلب نقض',
      partyName: 'طرف الدعوى',
      defendantName: 'اسم المدعى عليه',
      judgementCode: 'رقم الحكم',
      noJudgementFile: 'لا يوجد ملف حكم',
      addCassationRequestAttachment: 'المرفق مخصص للمستندات الداعمة فقط',
      cassationRequestAttachment: 'مرفقات طلب النقض',
      judgmentNotAvailableErrorMsg: 'لا يمكن اختيار الحكم',
      reasons: 'التسبيبات',
      fullExplanation: 'خدمة تتيح للمستفيدين تقديم طلب نقض على حكم صادر من محاكم الاستئناف خلال المدة الاعتراضية الخاصة بالحكم ، ويجب أن يتضمن طلب النقض رقم الحكم المعارض عليه، وتاريخه وأسباب المعارضة و لا يمكن للمستفيد التعديل على الطلب خلال المدة الاعتراضية وسيتم إحالة الطلب الى الدائرة القضائية بعد انتهاء المدة الاعتراضية',
      attachmentAlert: 'المرفقات مخصصة للمستندات الداعمة لطلب النقض، ولن يتم النظر في اللوائح الاعتراضية في المرفقات',
      shortExplanation: 'خدمة تتيح للمستفيدين تقديم طلب نقض على حكم صادر من محاكم الاستئناف',
      clickHere: ' اضغط هنا ',
      partyObjectionedAgainst: 'الطرف المعترض ضده',
      partyAgainstTitle: 'بيانات الطرف المعترض ضده',
      cassationReasons: 'الأسباب',
      addReason: 'إضافة سبب',
      addNewReason: 'إضافة سبب جديد',
      saveChanges: 'حفظ التغييرات',
      selectReasons: 'نوع السبب',
      reasonDescription: 'وصف السبب',
      positionOfJudgementText: 'موضعه من الحكم',
      statementOfViolation: 'بيان وجه المخالفة',
      violationEffect: 'أثرها فيه',
      hasObjectionedForAppeal: 'هل سبق إبداء هذا السبب لدى الاستئناف ؟',
      reasonForObjectionWithSameReasonAgain: 'موضع ذلك',
      reasonForNotMentionAtAppeal: 'سبب ذلك',
      selectJudgementText: 'انقر لاستعراض الحكم',
      judgementText: 'نص الحكم',
      highlightNote: 'قم بتحديد النص المطلوب وسيتم إضافته تلقائياً',
      stopExecutionDetailsTitle: 'طلب وقف التنفيذ',
      objectedPartiesHint: 'سيتم إشعار المعترض ضدهم لتقديم مذكرة الرد على الاعتراض خلال 10 أيام.',
      expireReplyDate: 'آخر مهلة للرد على طلب النقض هي : ',
      noReplies: 'تم انتهاء المهلة النظامية بدون رد',
      objectedPartiesTable: {
        partyName: 'اسم الطرف',
        partyRole: 'صفة الطرف',
        action: 'الإجراء',
        status: 'الحالة',
        added: 'مضاف',
        notAdded: 'غير مضاف',
      },
      casePartiesModalTitle: 'أطراف الدعوى',
      objectedPartiesRequired: 'يجب إضافة الأطراف المعترض ضدهم قبل إرسال الطلب',
      confirmationModal: {
        title: 'تأكيد',
        message: 'سيتم إشعار المعترض ضدهم (الموضحة أسماؤهم أدناه) لتقديم مذكرة الرد على الاعتراض لمدة 10 أيام.',
        pledge: 'الأطراف الموضحة أسماؤهم هم أطراف الاعتراض، ولا يوجد أطراف آخرون',
        confirm: 'متابعة',
        cancel: 'تراجع',
      },
      cassationRequestTitle: 'الحكم المراد نقضه',
      reasonText: {
        first: 'السبب الأول',
        second: 'السبب الثاني',
        third: 'السبب الثالث',
        fourth: 'السبب الرابع',
        fifth: 'السبب الخامس',
      },
      stopExecutionDetails: 'هل تريد تقديم طلب وقف التنفيذ ؟',
      stopExecutionDetailsReason: 'أسباب طلب وقف التنفيذ',
      stopExecutionDetailsReasonResult: 'الاثار المترتبة على طلب وقف التنفيذ',
      stopExecutionAttachment: 'مرفقات طلب وقف التنفيذ',
      removeObjectionStopExecutionAttachmentMessage: 'لا يمكن استرجاع مرفق طلب وقف التنفيذ بعد الحذف. هل ترغب بتأكيد الحذف؟',
      subjectOfCassationRequest: 'موضوع طلب النقض',
      reply: 'رد المعترض ضده على السبب :',
      subjectRequired: 'يرجى اختيار موضعه من الحكم',
      fullReplyText: 'ردود المعترض ضدهم :',
      noReply: 'لا يوجد رد',
      fullJudgmentObjection: 'موضع الاعتراض هو كامل الحكم',
      positionOfJudgementHint: 'اقتبس موضع الاعتراض من نص الحكم المعترض عليه',
      statementOfViolationHint: 'بيّن وجه المخالفة في الحكم وفقاً لنوع السبب المختار',
      violationEffectHint: 'بيّن أثر هذه المخالفة في الحكم محل طلب النقض',
      reasonForObjectionWithSameReasonAgainHint: 'اذكر موضع إبداء السبب أمام محكمة الاستئناف (مثل: رقم اللائحة، الفقرة، أو تاريخ المذكرة)، أو سبب عدم إبدائه إذا كانت الإجابة (لا).‌',
    },
    addNoteRequest: {
      title: 'طلب تقديم الرد على مذكرة الدعوى وتبادل المذكرات',
      lawsuitReplyNote: 'المذكرات المقدمة على القضية',
      addNote: 'إضافة الرد',
      noteText: 'الرد',
      prosecutionNotes: 'مذكرات المدعي',
      defenseNotes: 'مذكرات المدعى عليه',
      requesterName: 'الاسم',
      roleInCase: 'الصفة',
      replyNoteRequestDate: 'تاريخ إيداع المذكرة',
      requestText: 'نص المذكرة',
      fullExplanation: 'خدمة تتيح للمستفيدين إيداع مذكرة و يتم إضافة المذكرة لملف القضية بعد قبول الطلب من الدائرة القضائية',
      shortExplanation: 'خدمة تتيح للمستفيدين إيداع مذكرة و يتم إضافة المذكرة لملف القضية بعد قبول الطلب من الدائرة القضائية',
      attachments: 'المرفقات',
      fullNoteText: 'عرض نص المذكرة',
      requestTextNoData: 'لا يوجد بيانات لعرضها',
      actions: 'إجراءات',
    },
    judgeRejectionRequest: {
      title: 'طلب رد قاضي',
      judgeName: 'اسم القاضي',
      fullExplanation: 'هذا الإجراء ليس مخصصا لتقديم الاستفسارات إلى القاضي وطلب الرد بشأنها. يقدم هذا الطلب لرد القاضي عن نظر الدعوى وذلك عند وجود سبب أو أكثر من الأسباب الواردة في المادة السادسة والتسعون من نظام المرافعات الشرعية',
      shortExplanation: 'هذا الإجراء ليس مخصصا لتقديم الاستفسارات إلى القاضي وطلب الرد بشأنها. يقدم هذا الطلب لرد القاضي عن نظر الدعوى وذلك عند وجود سبب أو أكثر من الأسباب الواردة في المادة السادسة والتسعون من نظام المرافعات الشرعية',
    },
    incidentalRequest: {
      title: 'تصحيح الطلب الأصلي او تعديله',
      requests: 'الطلبات',
      requestsList: 'قائمة الطلبات',
      ChooseRequestsList: 'إختر قائمة الطلبات',
      claimAmount: 'مقدار المطالبة',
      lawsuitRequestType: 'نوع الطلب',
      lawsuitRequestStatus: 'حالة الطلب',
      fullExplanation: 'خدمة تتيح للمدعي أو من يمثله بتعديل الطلبات المالية أو تصحيحها أثناء سير الدعوى ولها ارتباط بالدعوى الأصلية الموجودة في صحيفة الدعوى ، وبعد قبول الطلب من الدائرة القضائية سيتم تحديث بيانات القضية',
      shortExplanation: 'خدمة تتيح للمدعي أو من يمثله بتعديل الطلبات المالية أو تصحيحها أثناء سير الدعوى ولها ارتباط بالدعوى الأصلية الموجودة في صحيفة الدعوى ، وبعد قبول الطلب من الدائرة القضائية سيتم تحديث بيانات القضية',
    },
    waiverOfAppealRequest: {
      title: 'نموذج طلب القناعة بالحكم',
      judgementCode: 'رقم الحكم',
      displayJudgement: 'عرض الحكم',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب إقرار القناعة بالحكم (التنازل عن حق الاستئناف) للأحكام الصادرة، كما يجب أن يتضمن طلب إقرار القناعة بالحكم على رقم الحكم',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب إقرار القناعة بالحكم (التنازل عن حق الاستئناف) للأحكام الصادرة، كما يجب أن يتضمن طلب إقرار القناعة بالحكم على رقم الحكم',
      onBehalfOf: 'نيابة عن',
      JudgmentInfo: 'بيانات الحكم',
      AcceptRequestMessage: 'في حال قبول الطلب من قبل جميع أطراف الدعوى سيتم إسقاط حق الاستئناف للحكم',
      SuccessReplyMessage: 'تم إرسال الرد بنجاح',
      replyToRequest: 'الرد على الطلب',
      replyConfirmationMessage: 'هل أنت متأكد من إرسال الرد؟',
    },
    liftReferRequest: {
      title: 'طلب رفع التبليغ بالمراجعة',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب رفع التبليغ بالمراجعة عند صدور قرار لدى المستفيد بالتبليغ بالمراجعة لدى وزارة العدل',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب رفع التبليغ بالمراجعة عند صدور قرار لدى المستفيد بالتبليغ بالمراجعة لدى وزارة العدل',
    },
    proceedAbandonedCase: {
      title: 'طلب استمرار السير في الدعوى لغياب المستأنف',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب استمرار السير في الدعوى عند تغيب المستأنف عن حضور جلسة الاستئناف',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب استمرار السير في الدعوى عند تغيب المستأنف عن حضور جلسة الاستئناف',
    },
    viewCaseRecord: {
      title: 'طلب الاطلاع على ملف القضية',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب للإطلاع على ملف القضية',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب للإطلاع على ملف القضية',
    },
    correctionJudgementRequest: {
      title: 'طلب تصحيح الحكم',
      partyName: 'طرف الدعوى',
      subRequestType: 'نوع الطلب',
      judgementCode: 'رقم الحكم',
      noJudgementFile: 'لا يوجد ملف حكم',
      editJudgementText: 'النصوص المراد تصحيحها',
      addJudgementTextForCorrection: 'إضافة نص للتصحيح آخر؟ يمكن إضافة 5 نصوص كحد أقصى',
      addJudgementTextForCorrectionBtn: 'إضافة نص للتصحيح',
      judgementSectionLabel: 'أقسام صك الحكم',
      judgementSectionText: 'النص المستجلب المراد تصحيحه',
      repeatedText: 'الخطأ متكرر',
      theCorrectText: 'النص الصحيح',
      attachment: 'المرفق',
      judgementNotAvailableErrorMsg: 'لا يمكن اختيار الحكم، يجب أن يكون الحكم نهائي أو غير قطعى',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب تصحيح الحكم على الاحكام النهائية سواء كانت الاحكام صادرة من الدرجة الأولى أو من الاستئناف',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب تصحيح الحكم على الاحكام',
      removeAttachment: 'حذف المرفق',
      selectJudgementErrorMsg: 'عفوا، يرجى اختيار رقم الحكم',
      selectJudgementTextErrorMsg: 'عفوا، يرجى تحديد النص المراد تصحيحه',
      addJudgementCorrectionTextErrorMsg: 'عفوا، يرجى اضافة النص الصحيح',
      addJudgementSectionTextErrorMsg: 'عفوا، يرجى اختيار قسم صك الحكم',
      accept: 'تأكيد',
      cancel: 'إلغاء',
      warningTextDelete: 'هل أنت متأكد من حذف النص؟',
      highlightError: 'عفوا، يرجى البدأ بتحديد النص من اليمين إلى اليسار',
      highlightNote: 'يرجى تظليل النص المراد تصحيحه',
      selectValidTextErrorMsg: 'عفوا، يرجى إعادة محاولة تظليل النص',
      selectTextErrorMsg: 'عفوا يرجى التأكد من تحديد النص بشكل صحيح',
    },
    interpretationJudgementRequest: {
      title: 'طلب تفسير الحكم',
      partyName: 'طرف الدعوى',
      subRequestType: 'نوع الطلب',
      editJudgementText: 'النصوص المراد تفسيرها',
      judgementCode: 'رقم الحكم',
      noJudgementFile: 'لا يوجد ملف حكم',
      theInterpretationText: 'النص المفسر',
      attachment: 'المرفق',
      notes: 'ملاحظات',
      addJudgementTextForInterpretation: 'إضافة نص للتفسير آخر؟ يمكن إضافة 5 نصوص كحد أقصى',
      judgementSectionText: 'النص المستجلب المراد تفسيره',
      judgementNotAvailableErrorMsg: 'لا يمكن اختيار الحكم، يجب أن يكون الحكم نهائي أو غير قطعى',
      judgementSectionLabel: 'أقسام صك الحكم',
      addJudgementTextForInterpretationBtn: 'إضافة نص للتفسير',
      fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب تفسير الحكم على الاحكام النهائية سواء كانت الاحكام صادرة من الدرجة الأولى أو من الاستئناف',
      shortExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب تفسير الحكم على الاحكام',
      removeAttachment: 'حذف المرفق',
      selectJudgementErrorMsg: 'عفوا، يرجى اختيار رقم الحكم',
      selectJudgementTextErrorMsg: 'عفوا، يرجى تحديد النص المراد تفسيره',
      selectJudgementErrorMessage: 'عفوا، يرجى تحديد موضعه من الحكم',
      addJudgementSectionTextErrorMsg: 'عفوا، يرجى اختيار قسم صك الحكم',
      addJudgementInterpretationTextErrorMsg: 'عفوا، يرجى اضافة النص المفسر',
      addJudgementInterpretationNoteErrorMsg: 'عفوا، يرجى اضافة الملاحظات',
      accept: 'تأكيد',
      cancel: 'إلغاء',
      warningTextDelete: 'هل أنت متأكد من حذف النص؟',
      highlightNote: 'يرجى تظليل النص المراد تفسيره',
      cassationHighlightNote: 'يرجى تظليل النص',
      selectValidTextErrorMsg: 'عفوا، يرجى إعادة محاولة تظليل النص',
      loadJudgementSectionsErrorMsg: 'فشل في تحميل أقسام الحكم',
    },
    reconsiderationFromNonCaseParty: {
      title: 'طلب التماس إعادة نظر',
      fullExplanation: 'خدمه تتيح للمستفيد - من غير أطراف الدعوى - من كان الحكم حُجه عليه ولم يكن قد أدخل أو تدخل في الدعوى وذلك بالتقدم بالاعتراض عن طريق التماس إعادة النظر في الأحكام النهائية',
      shortExplanation: 'خدمه تتيح للمستفيد - من غير أطراف الدعوى - من كان الحكم حُجه عليه ولم يكن قد أدخل أو تدخل في الدعوى وذلك بالتقدم بالاعتراض عن طريق التماس إعادة النظر في الأحكام النهائية',
      displayJudgement: 'عرض صك الحكم',
      objectionJudgementText: 'نصوص الحكم المستجلبة المراد الاعتراض عليها',
      addJudgementTextForObjection: 'إضافة نص الاعتراض عن الحكم؟ يمكن إضافة 5 نصوص كحد أقصى (اختياري)',
      addJudgementTextForObjectionBtn: 'إضافة نص الاعتراض عن الحكم',
      judgementSectionText: 'النص المستجلب المراد الاعتراض عليه',
      repeatedText: 'الخطأ متكرر',
      theCorrectText: 'النص الصحيح',
      accept: 'تأكيد',
      cancel: 'إلغاء',
      warningTextDelete: 'هل أنت متأكد من حذف النص؟',
      judgementSectionLabel: 'أقسام صك الحكم',
      selectValidTextErrorMsg: 'عفوا، يرجى إعادة محاولة تظليل النص',
      highlightNote: 'يرجى تظليل النص المراد الاعتراض عليه',
      addJudgementSectionTextErrorMsg: 'عفوا، يرجى اختيار قسم صك الحكم',
      selectJudgementTextErrorMsg: 'عفوا، يرجى تحديد النص المراد الاعتراض عليه',
      editJudgementText: 'النصوص المراد الاعتراض عليها',
      argumentAndExecution: 'الحجة و التنفيذ',
      applicantRole: 'صفة مقدم الطلب',
      chooseRole: 'اختر الصفة',
      requestApplicant: {
        title: 'بيانات مقدم الطلب',
        personalInfo: 'البيانات الشخصية',
        mobileNumber: 'الهاتف الجوال',
        email: 'البريد الالكتروني',
        invalidNumber: 'رقم الترخيص غير صحيح',
        licenceNumber: 'رقم الترخيص',
        mojLicenceNumber: 'رقم ترخيص وزارة العدل',
        partyType: 'الصفة',
        socialIdType: 'نوع الهوية',
        socialId: 'رقم الهوية',
        birthDate: 'تاريخ الميلاد',
        firstName: 'الاسم الأول',
        fatherName: 'اسم الأب',
        thirdName: 'اسم الجد',
        familyName: 'اسم العائلة',
        fullName: 'الاسم الكامل',
        nationality: 'الجنسية',
        gender: 'النوع',
        originalTitle: 'بيانات الطرف الاصيل',
        attorneyDetails: 'بيانات الوكالة',
        validateIdentityNumber: 'تحقق',
        personVerify: 'يتم التحقق من الهوية عن طريق (إدخال رقم الهوية وتاريخ الميلاد) أو (رقم الهوية والاسم الأول)',
        // party type selection specific to reconsideration request
        partyTypeSelection: {
          type: 'النوع',
          reference: 'الصفة',
          isInheritor: 'إضافة بصفة مورث (متوفى)',
          isInheritor1: 'هل المطالبة متعلقة بمتوفى؟',
          isOrganizationOwner: 'إضافة فرد بصفة (مالك مؤسسة)',
        },
        // representative form specific labels
        representativeForm: {
          title: 'نموذج الممثل',
          representativeInfo: 'بيانات الممثل',
          representativeType: 'نوع الممثل',
          legalRepresentative: 'ممثل قانوني',
          attorney: 'وكيل',
          guardian: 'ولي أو وصي',
          selectedPartyRequired: 'يجب اختيار نوع الطرف',
          addressRequired: 'العنوان مطلوب',
        },
      },
      argumentBody: 'نص الحجة للاعتراض علي الحكم الصادر',
      stopExecution: 'هل تريد وقف التنفيذ ؟',
      stopExecutionNotes: 'ملاحظات',
      tableHeader: {
        requestCode: 'رقم الطلب',
        requestStatusName: 'حالة الطلب',
        caseCode: 'رقم القضية',
        requestType: 'نوع الطلب',
        requestDate: 'تاريخ الطلب',
      },
      lawyerNotificationMessage: 'للوصول إلى الطلبات بصفة محامي، الرجاء الدخول عبر ناجز المحامين',
    },
    requestSendSuccessfully: 'تم إرسال الطلب بنجاح',
    requestCode: 'رقم الطلب',
    sendRequestConfirmationMessage: 'هل أنت متأكد من إرسال الطلب؟',
    relatedPartyInfo: 'بيانات مقدم الطلب',
    canNotAddDuplicateReason: 'لا يمكن إضافة السبب لأنه موجود مسبقاً',
    validationSummaryTitle: 'لا يمكن تقديم الطلب للأسباب التالية',
    waiverRequestConditionValidAttachmentRequired: 'عفواً، يجب إرفاق مرفق تحقق الشرط للمتابعة',
    requestTypePrerequisitesInfo: 'متطلبات الطلب',
    successAlertMessage: 'رسالة نجاح',
    reasons: 'السبب',
    btnAttachment: 'زر رفع مرفق',
    attachmentName: 'إسم المرفق',
    confirmModel: {
      title: 'تأكيد',
      confirmMessage: 'هل أنت متأكد من حذف السبب؟',
      yes: 'نعم',
      no: 'لا',
    },
    applicantCaseParty: 'أطراف الدعوى',
    representativeCaseParty: 'بيانات الممثل الشخصية',
    representativeType: 'نوع الممثل',
    addMyInfoRepresentative: 'إضافة بياناتي كممثل',
    partyTypeName: 'النوع',
    firmName: 'الاسم',
    commercialRegisterationNumber: 'رقم السجل التجاري',
    casePartyRoleName: 'الصفة',
    socialId: 'رقم الهوية',
  },
  caseRelatedProcedure: {
    replyToRequest: 'الرد على الطلب',
    period: period => `مهلة الرد ${period} يوم من تاريخ بدء الإجراء`,
    backToCaseFile: 'العودة الى ملف القضية',
    attachmentAlreadyExist: 'لقد تم اضافة هذا الملف مسبقا',
    attachmentRequired: 'يُلزم اضافة مرفق لتقديم الاجراء',
    backToProcedures: 'العودة لملف القضية',
    successReplyMessage: 'تم إرسال الرد بنجاح',
    title: 'نموذج إجراء استكمال بيانات القضية',
    relatedPartyInfo: 'بيانات مقدم الطلب',
    sendConfirmationMessage: 'هل أنت متأكد من إرسال الطلب؟',
    validationSummaryTitle: 'لا يمكن تقديم الطلب للأسباب التالية',
    generalAcceptanceCriteria: 'اشتراطات المحاكم العامة',
    commercialAcceptanceCriteria: 'اشتراطات المحاكم التجارية',
    laborAcceptanceCriteria: 'اشتراطات المحاكم العمالية',
    acceptanceCriteria: 'اشتراطات محاكم',
    courts: 'المحكمة المختصة',
  },
  judgementForms: {
    modalTitle: 'نموذج الحكم',
    columnId: 'الرقم التعريفي',
    judgementFormName: 'اسم نموذج الحكم',
    judgementCode: 'صك رقم:',
  },
  dynamicFormAdmin: {
    addFieldSection: {
      suggestedTechnicalName: 'تخصيص الاسم التقني (Suggested Technical Name)',
      formula: 'القالب',
      formulaEdit: 'عدم إمكانية التعديل على الصياغة',
      customComponent: 'اسم الحقل المخصص (Field Component Name)',
      section: {
        title: 'بيانات السكشن (Section Data)',
        add: 'إضافة سكشن (Add Section) ',
      },
      button: {
        title: 'بيانات الزر (Button Data)',
        add: 'إضافة زر (Add Button)',
      },
      dataSource: {
        listTitle: 'قائمة البيانات',
        textName: 'الاسم التقني لتعيين القيمة',
        dataSourceType: 'نوع الحقل',
        lookups: 'القوائم (Lookups)',
        externalServiceData: 'بيانات من خدمة خارجية',
        internalData: 'بيانات من الدعوى',
        currentFormData: 'بيانات من النموذج الحالي',
        addData: 'إضافة بيانات',
        valueName: 'الاسم',
        valueId: 'القيمه',
        module: 'موديول',
        requestType: 'النوع',
        endpoint: 'عنوان الخدمة',
        pickLists: 'اختر مصدر البيانات (select lookup)',
        source: 'المصدر',
        sourceTechnicalName: 'الاسم التقني للمصدر',
        itemValue: 'الاسم التقني للقيمة (default: <id>)',
        itemText: 'الاسم التقني للاسم المعروض (default: <name>)',
      },
    },
    requestsForm: {
      requests: 'الطلبات',
      requestsList: 'قائمة الطلبات',
      requestTemplate: 'طلب المدعي',
      requestAlertTitle: 'معلومات هامه',
      requestAlertMessage: 'عزيزي المستفيد: لا يمكنك التعديل على الطلب المحدد من قائمة الطلبات بعد اكتمال الطلب وإحالته إلى الدائرة القضائية، وأي تعديل لاحق يخالف الطلب المحدد يؤدي إلى رفض الطلب؛ بناءً على المادة ٢/٨٣ من اللائحة التنفيذية لنظام المرافعات الشرعية.',
      requestData: 'بيانات الطلب',
    },
    customComponents: {
      technicalNamesList: 'قائمه الاسماء التقنيه - technical names',
      checkHeirsData: {
        sectionTitle: 'بيانات صك حصر الورثة',
        instrumentNumber: 'رقم الصك',
        socialId: 'رقم الهوية',
        deceasedSectionTitle: 'بيانات المورث',
        deceasedNameLabel: 'اسم المورث',
        deceasedDeathDateLabel: 'تاريخ الوفاة',
        deceasedGenderLabel: 'الجنس',
      },
      inheritorInquiry: {
        sectionTitle: 'الاستعلام عن هوية المورث',
        socialId: 'هوية المورث',
      },
      BuildingInfo: {
        sectionTitle: 'بيانات صك ملكية العقار',
        deedId: 'رقم الصك',
        deedDate: 'تاريخ الصك',
        realEstateSectionTitle: 'بيانات العقار',
        buildingTypeLabel: 'وصف العقار',
        cityLabel: 'المدينة',
        districtLabel: 'الحي',
        buildingOwnershipDeedSourceLabel: 'مصدر الصـك',
        buildingOwnershipDeedNumberLabel: 'الرقم',
        buildingOwnershipDeedDateLabel: 'تاريخ',
        buildingOwnershipDeedAreaLabel: 'مساحه',
      },
      OwnershipDeedInfo: {
        sectionTitle: 'معلومات صك الملكية',
        deedId: 'رقم الصك',
        cityName: 'مدينة العقار',
        deedDate: 'تاريخ الصك',
        deedInfo: 'معلومات صك الملكية',
        deedDescription: 'معلومات صك الملكية',
        realEstateType: 'نوع العقار',
        realEstateCity: 'مدينة العقار',
        ownerName: 'اسم المالك',
        deedSource: 'مصدر الصك',
        deedNo: 'رقم الصك',
        serialNo: 'رقم القطعة',
        blockNumber: 'رقم البلوك',
        planNumber: 'رقم المخطط التنظيمي',
        area: 'مساحة العقار',
      },
      RealEstateContractDetails: {
        sectionTitle: 'بيانات العقد المبرم بين الطرفين',
        contractNumber: 'رقم عقد الإيجار',
        partySocialId: 'رقم هوية احد اطراف العقد',
        versionNumber: 'رقم نسخة العقد',
      },
      judgementDocument: {
        sectionTitle: 'صك الحكم',
        caseCode: 'رقم القضية',
        identityNumber: 'رقم الهوية',
        caseYear: 'سنة القضية',
        judgementName: 'صك الحكم',
        judgementCode: 'رقم صك الحكم',
        verificationSucceededUploadSucceeded: 'تم التحقق بنجاح وتم إرفاق صك الحكم',
        verificationSucceededUploadFailed: 'تم التحقق بنجاح ولم يتم إرفاق صك الحكم',
        courtName: 'المحكمة المصدرة للحكم',
        subCircleName: 'الدائرة المصدرة للحكم',
      },
      judicialInformingDetails: {
        sectionTitle: 'بيانات الإخطار بأداء الحق',
        isNotifiedBeforeToBeDoRight: 'هل سبق وأن تم الإخطار بأداء الحق؟',
        judicialInformingApproach: 'اّلية تبليغ الإخطار',
        requestCode: 'رقم الطلب',
        prosecutorsMenu: 'قائمة أسماء المدعين',
        categoryName: 'مرفق التبليغ',
        uploadSuccess: 'تم التحقق بنجاح وتم ارفاق وثيقة الأخطار',
        uploadFailed: 'يرجى إدخال الرقم الصحيح لرقم طلب أداء الحق الصادر من التبليغ العدلي',
        informStatusSuccess: 'تم التبليغ',
        judicialInformingPlatform: 'منصة التبليغ العدلي',
        other: 'غير ذلك',
        verificationFailed: 'لم يتم التبليغ',
        invalidJudicialInformingDate: 'تاريخ الإخطار لاحق لتاريخ طلب قيد الدعوى؛ يرجى تقديم صحيفة الدعوى بعد مضي مدة الإخطار',
        invalidData: 'عفواً ،يرجى إدخال الرقم الصحيح لرقم طلب أداء الحق الصادر من التبليغ العدلي',
        casePartyStatus: 'حالة أطراف الدعوى',
        isDefendantInformingWithJudicialInforming: 'هل تم إخطار المدعي عليه بأداء الحق كتابة',
        judicialInformingDefendantArrivalDate: 'تاريخ وصول الإخطار إلى المدعى عليه',
      },
      ContractDetails: {
        sectionTitle: 'بيانات العقد الأساسية',
        typeOfContract: 'نوع العقد',
        contractNumber: 'رقم عقد إيجار الموحد',
        partyBirthDate: 'تاريخ ميلاد طرف العقد',
        partySocialId: 'رقم هوية طرف العقد',
        inquiryPurpose: 'الغرض من الإستعلام',
        inquiryRequesterID: 'رقم هوية المستعلم',
        inquiryRequesterName: 'اسم المستعلم',
        versionNumber: 'رقم النسخة',
        requestNumber: 'رقم الطلب',
        categoryName: 'عقد الإيجار',
        verificationRequired: 'يرجئ التحقق اولا',
        realStateConfirmationText: 'تم إضافة عقد الإيجار في المرفقات',
        residentialQuestionValidation: 'تنبية: استنادًا لتعميم معالي وزير العدل رقم 13/ت/7656 بتاريخ 4/5/1440هـ لابد أن يسجل العقد في الشبكة الإلكترونية (إيجار) عن طريق البوابة  https://www.ejar.sa/',
        itemValidation: 'تنبية: يُعد عقد الإيجار الموثّق في شبكة إيجار سندًا تنفيذيًا بموجب قرار مجلس الوزراء رقم (131) وتاريخ 3-4-1435هـ؛ لذا يرجى التقدم بطلب تنفيذ من خلال البوابة الإلكترونية https://najiz.moj.gov.sa/Home/More/3',
        purposeOfTheLease: 'الغرض من التأجير',
        residentialQuestion: 'هل تم التعاقد أو الاتفاق بتاريخ 4/5/1440هـ فما بعد؟',
        commercialQuestion: 'هل تم التعاقد أو الاتفاق بتاريخ 29/6/1441هـ فما بعد؟',
        durationQuestion: 'هل مدة العقد ثلاثة أشهر فأقل',
        descriptionOfTheLease: 'وصف العيـن محل الأجرة',
        typeOfTheLease: 'هل نوع العقد (إيجار منتهي بالتمليك)',
        contractFee: 'هل تتضمن المطالبة أجرة ضمن فترة العقد',
        contractFeeValidation: 'تنبية: يُعد عقد الإيجار الموثّق في شبكة إيجار سنداً تنفيذياً بموجب تعميم معالي وزير العدل رقم13/ت/8843 بتاريخ 19/12/1443هـ لذا يرجى التقدم بطلب تنفيذ من خلال البوابة الالكترونية https://www.najiz.sa/applications/iexecution',
        item: 'هل تم إضافة شروط إضافية في البند السادس عشر من العقد',
        item2: 'هل تم إضافة شروط إضافية في العقد',
        item3: 'هل مازال العقد سارى؟',
        item3Validation: 'يُعد عقد الإيجار الموثّق في شبكة إيجار سندًا تنفيذيًا بموجب قرار مجلس الوزراء رقم (131) وتاريخ 3-4-1435هـ؛ لذا يرجى التقدم بطلب تنفيذ من خلال البوابة الإلكترونية https://najiz.moj.gov.sa/Home/More/3',
        verificationSucceededUploadFailed: 'تم التحقق بنجاح ولم يتم إرفاق عقد الإيجار',
        verificationSucceededUploadSucceeded: 'تم التحقق بنجاح وتم إرفاق عقد الإيجار',
        typeOfContractValidation: 'تنبية: استناداً لتعميم وزير العدل رقم 13/ت/8843 بتاريخ 19/12/1443ه لابد أن يسجل العقد في الشبكة الإلكترونية (إيجار) عن طريق البوابة https://www.ejar.sa/',
        firstPartyName: 'اسم المؤجر',
        secondPartyName: 'اسم المستأجر',
        partySocialIdType: 'نوع الهوية',
        partySocialIdNumber: 'رقم الهوية',
        fullAddress: 'بيانات العين المؤجرة',
      },
      checkDeeds: {
        title: 'التحقق من حالة الزواج',
        eventData: 'التاريخ',
        husbandInfo: 'بيانات الزوج',
        husbandNationalId: 'رقم هوية الزوج',
        husbandBirthDate: 'تاريخ ميلاد الزوج',
        husbandName: 'إسم الزوج',
        husbandBirthCity: 'مدينة ميلاد الزوج',
        wifeInfo: 'بيانات الزوجة',
        wifeNationalId: 'رقم هوية الزوجة',
        wifeBirthDate: 'تاريخ ميلاد الزوجة',
        wifeName: 'إسم الزوجة',
        wifeBirthCity: 'مدينة ميلاد الزوجة',
        martialStatus: 'حالة الزواج',
        divorceStatus: 'بيان الطلاق',
      },
    },
  },
  feesOfLawyerSimilarCase: {
    caseCode: 'رقم القضية',
    caseYear: 'سنة القضية',
  },
  home: {
    filter: {
      roleInCase: 'الصفة',
      court: 'المحكمة',
      caseType: 'نوع القضية',
      requestStatus: 'حالة الطلب',
      fromDate: 'التاريخ من',
      toDate: 'التاريخ الى',
      judgementType: 'نوع الحكم',
      requestType: 'نوع الطلب',
      decisionType: 'نوع القرار',
      criminalNo: 'الرقم الجنائي',
      judgementCode: 'رقم الحكم',
      requestCode: 'رقم الطلب',
    },
    tabCommon: {
      latestUpdates: 'آخر التحديثات',
      latest: 'آخر',
      updates: 'التحديثات',
      noUpdates: 'عفواً، لم يتم العثور على تحديثات',
      caseCode: 'رقم القضية',
      deedId: 'رقم الصك',
      sendToApply: 'إرسال للتنفيذ',
      objection: 'اعتراض',
      caseDetails: 'تفاصيل القضية ',
      caseRequests: 'الطلبات على القضية',
      procedures: 'إجراءات',
      caseDate: 'تاريخ القضية',
      caseType: 'نوع القضية',
      sakDate: 'تاريخ الصك',
      roleInCase: 'الصفة',
      judgementCode: 'رقم الحكم',
      courtName: 'المحكمة',
      subCircleName: 'الدائرة',
      requestCode: 'رقم الطلب',
      decisionCode: 'رقم القرار',
      decisionNumber: 'رقم القرار',
      judgementNumber: 'رقم الحكم',
      prosecutorName: 'المدعي',
      defendantName: 'المدعى عليه',
      requestStatus: 'حالة الطلب',
      status: 'الحالة',
      requesterName: 'مقدم الطلب',
      decisionStatus: 'حالة القرار',
      requestType: 'نوع الطلب',
      decisionType: 'نوع القرار',
      requestDate: 'تاريخ الطلب',
      decisionDate: 'تاريخ القرار',
      issuer: 'جهة الإصدار',
      judgementType: 'نوع الحكم',
      filterWithRequestCode: 'البحث برقم الطلب',
      filterWithJudgementCode: 'البحث برقم الصك',
      filterWithCaseCode: 'البحث برقم القضية',
      filterWithDecisionCode: 'البحث برقم القرار',
      newRequest: 'طلب جديد',
      requestLog: 'سجل الطلب',
      showCaseFile: 'عرض ملف القضية',
      requestLogTooltip: 'لمعرفة أسباب عدم الاكتمال و كذلك العمليات التي تمت على الطلب، اضغط هنا',
      sessionType: 'نوع الجلسة',
      today: 'اليوم',
      sessionMechanism: 'آلية الانعقاد',
      newSubRequest: 'انشاء طلب',
      newReplyMemo: 'تقديم مذكرة الجواب',
      all: 'الكل',
      incomingRequestsAlert: 'هذا النوع من الطلبات لا يلزم أن تكون طرفاً في القضية',
      settings: 'إجراءات',
      chooseSettings: ' اختر الإجراء',
      viewRuling: 'عرض الحكم',
      requests: 'طلبات الالتماس',
      requestsDesc: 'طلبات التنازل',
      correctionDecision: 'قرار تصحيح',
      isBankruptcyMigrated: 'افلاس منقولة',
      isBankruptcyRequestMigrated: 'مكتمل',
      bankruptcyCaseAlert: 'هذه القضية من قضايا الإفلاس المنقولة',
    },
    judgementDelivery: {
      judgementCode: 'رقم الحكم',
      criminalNumber: 'الرقم الجنائي ',
      caseTypeName: 'نوع القضية',
      courtName: 'اسم المحكمة',
      conclusiveDate: 'تاريخ الحكم',
      deliveryStatus: 'حالة الاستلام',
      deliveryStatusHeader: 'حالة استلام الحكم',
      show: 'تحديث على شرط التنازل',
      showConfirmation: 'هل أنت متأكد من استعراض الحكم',
      showConfirmationSubmessage: 'تأكيدك على استعراض الحكم يعني الموافقة على استلام الحكم',
      ConfirmDeliveryTitle: 'تأكيد استلام الحكم',
      judgementRead: 'مقروء',
      judgementDelivered: 'مستلم',
      caseClassification: 'التصنيف',
      judgementNumber: '  الحكم رقم ',
      circleName: 'اسم الدائرة',
      sakNumber: 'رقم صك الحكم',
      casecode: 'رقم القضية',
      petitionRequestsStatus: 'حالة الالتماس',
      judgementDetails: 'تفاصيل الحكم',
      judgement: 'الحكم',
    },
    petitionRequests: {
      requestCode: 'رقم الطلب',
      courtName: 'إسم المحكمة',
      requestDate: 'تاريخ الطلب',
      requestStatus: 'حالة الطلب',
    },
    tabs: {
      cases: 'القضايا',
      lawsuitRequests: 'صحائف الدعوى',
      requests: 'الطلبات',
      outgoingRequests: 'الطلبات الصادرة',
      judgements: 'الأحكام',
      judgement: 'حكم',
      decisions: 'القرارات',
      decision: 'قرار',
      petitionDecisionsJudgements: 'تفاصيل الأحكام و القرارات',
      updates: 'التحديثات',
      legacyCaseRequests: 'طلبات تحديث القضايا',
      archivedCases: 'القضايا المؤرشفة',
      all: 'الكل',
      incomingRequests: 'الطلبات الواردة',
      finalJudgements: 'الأحكام النهائية',
    },
    upcomingSessions: {
      title: 'الجلسات القادمة',
      caseNumber: 'قضية رقم',
      sessionType: 'طريقة انعقاد الجلسة',
      copyLink: 'مشاركة الرابط',
      showAllSessions: 'استعراض جميع الجلسات',
      sessionsList: 'قائمة الجلسات',
      exportSessions: 'تحميل الجلسات',
      attendanceSession: 'حضورية',
      remoteSession: 'عن بعد',
      courtLocation: 'موقع المحكمة',
      today: 'اليوم',
      tomorrow: 'غداً',
      copied: 'تم نسخ الرابط',
      writtenPleading: 'المرافعة الكتابية',
      enterSession: 'الرجوع للجلسة',
      changeSessionRequest: 'طلب تغيير موعد الجلسة',
      requestApproveAttendanceRequest: 'طلب إثبات حضور الجلسة',
      attendanceRegister: 'حضور الجلسة',
      registrationSuccessful: 'تم تسجيل حضورك بنجاح',
      termsAndConditions: 'الشروط والأحكام',
      attendanceRegisterPart1: 'سيكون التسجيل متاح قبل بدء الجلسة بـ 30 دقيقة إلى وقت انتهاء الجلسة',
      attendanceRegisterFirstConditions: ' عدم تسجيل أو تصوير الجلسة عن بعد، أو جزء منها، بأي وسيلة كانت، وسواء كان التسجيل صوتياً أو مرئياً.',
      attendanceRegisterSecondConditions: 'عدم انتحال المستفيد لأي شخصية أخرى، مهما كانت العلاقة أو القرابة، ولو بوجود وكالة سارية.',
      attendanceRegisterPart2: 'وفي حال مخالفتك هذه الشروط والأحكام، فإنك ستكون معرضاً للمساءلة القانونية، وتطبيق العقوبات المنصوص عليها في الأنظمة. وبدخولك في هذه الخدمة، فإن ذلك يعد قبولاً لهذه الشروط والأحكام، وإقرار بعدم استخدام البوابة بشكل يخالف أي أنظمة في المملكة أو اتفاقية دولية أو بروتوكولات خاصة بالانترنت. كما أن جميع ما يقدم في البوابة من مرافعة كتابية أو وثائق أو مستندات أو حضور لجلسات عن بعد ستكون موثقة في سجلات الوزارة.',
      agreeOnTermsAndConditions: 'اطلعت ووافقت على الشروط والأحكام',
      toRedirectToSessionLink: 'للذهاب لرابط الجلسة',
      goToSession: 'الذهاب للجلسة',
    },
  },
  grades: {
    first: 'الدرجة الاولى',
    appeal: 'الاستئناف',
    higher: 'العليا',
  },
  judgementSections: {
    waqae: 'الوقائع',
    reasons: 'الأسباب',
    mantoq: 'منطوق الحكم',
    other: 'اخرى',
  },
  stopDurations: {
    oneMonth: 'شهر',
    twoMonths: 'شهران',
    threeMonths: 'ثلاثة أشهر',
    fourMonths: 'أربعة أشهر',
    fiveMonths: 'خمسة أشهر',
    sixMonths: 'ستة أشهر',
  },
  stopOrResumeLawsuitRequestType: {
    stopLawsuitRequestType: 'وقف السير في الدعوى',
    resumeLawsuitRequestType: 'استمرار السير في الدعوى',
  },
  correctionOrInterpretationOfJudgmentRequestType: {
    correctionRequestType: 'طلب تصحيح الحكم',
    interpretationRequestType: 'طلب تفسير الحكم',
  },
  waiverOfAppealRequestResponse: {
    Approve: 'قبول الطلب',
    Reject: 'رفض الطلب',
  },
  cassationObjectionReasons: {
    oppositeOfIslamicLaw: 'مخالفة الشريعة الإسلامية وما يصدره وليّ الأمر من أنظمة لا تتعارض معها',
    badCourtHierarchy: 'صدور الحكم من محكمة غير مشكّلة تشكيلًا سليمًا طبقًا لما نص عليه النظام',
    courtOrCircleUnspecialized: 'صدور الحكم من محكمة أو دائرة غير مختصة',
    notAccurateDescription: 'الخطأ في تكييف الواقعة أو وصفها وصفًا غير سليم',
    rulingOnDisputeTheFinalJudgmentAddressedDifferencesBetweenParties: 'فصله في نزاع خلافًا لحكم آخر سبق أن صدر بين أطراف الدعوى',
  },
  caseFile: {
    deedId: 'رقم الصك',
    secretJudgementsInfoTitle: 'لا يمكن عرض الحكم',
    secretJudgementsInfo: 'الرجاء مراجعه المحكمة للاطلاع على الحكم',
    noJudgementLine1: 'لم يتم إصدار الحكم حتى الآن،',
    noJudgementLine2: ' سيتم إصدار حكم على القضية بتاريخ ',
    noJudgementsOnThisCase: 'لا توجد أحكام صادرة على هذه القضية',
    judgementToBe: 'سيصدر الحكم على القضية بتاريخ ',
    hijri: ' هـ ',
    tableHeader: {
      caseCode: 'رقم القضية',
      caseDate: 'تاريخ القضية',
      court: 'المحكمة',
      circle: 'الدائرة القضائية',
      caseStatusName: 'حالة القضية',
      caseCategoryName: 'تصنيف القضية',
      caseType: 'نوع القضية',
      roleInCase: 'الصفة',
    },
    partiesCard: {
      roleInCase: 'الصفة',
      nationality: 'الجنسية',
      casePartyRole: 'الصفة',
    },
    tabHeaders: {
      sessions: 'الجلسات',
      caseDetails: 'موضوع الدعوى',
      caseParties: 'أطراف الدعوى',
      requests: 'الطلبات',
      judgements: 'الأحكام',
      decisions: 'القرارات',
      expertRequests: 'طلبات الخبرة',
      fees: 'التكاليف القضائية',
      lawsuitReplyForm: 'مذكرة الدفاع الأولى',
      documents: 'المرفقات',
      procedures: 'الإجراءات',
      suspensions: 'المطالبات المعلقة',
    },
    session: {
      extendPleading: 'طلب تمديد مدة الترافع',
      requestPublicReply: 'طلب رد إضافي',
      sessionInfoModalTitle: ':ضبط الجلسة',
      dabtAttestation: 'تم الاطلاع على تدوين وقائع المرافعة، والمصادقة على ضبط الجلسة',
      sessionSubject: 'الدعوى',
      sessionResponse: 'الإجابة',
      sessionReasons: 'الأسباب',
      sessionJudgement: 'الحكم',
      sessionText: 'المرافعة',
      caseSessionNoData: 'لا يوجد بيانات لعرضها',
      remoteArgument: {
        lastReplyDate: 'اخر موعد للرد',
        attachmentAllowed: 'يمكن ارفاق ملف',
        attachmentNotAllowed: 'لا يمكن ارفاق ملف',
        replyToJudgeMessage: 'الرد على الدائرة القضائية',
        replyRequests: 'طلبات الرد الإضافي',
        requestNumber: 'الرقم',
        requestDate: 'التاريخ',
        requestStatus: 'الحالة',
        requestReason: 'السبب',
        caseCode: 'رقم القضية',
        hasReplied: 'تم الرد',
        notes: 'ملاحظات',
        replyDisabled: 'تم إيقاف الرد من الدائرة القضائية',
        expertReply: 'الرد على الخبير',
        messageFromJudicialDepartment: 'رسالة من الدائرة القضائية',
        messageFromExpert: 'رسالة خبير',
        sessionStatus: 'الحالة',
        responseAndRequests: 'الردود والطلبات',
        downLoadFile: 'تحميل الملف',
        endDate: 'تاريخ الانتهاء',
        reply: 'الرد',
        addReply: 'إضافة الرد',
        replyNote: 'تبادل المذكرات',
        termsAndConditions: 'الشروط والأحكام',
        reason: 'السبب',
        confirmSendTitle: 'تأكيد الارسال',
        confirmSendMessage: 'هل أنت متأكد من إرسال الرد ؟',
        requesterName: 'الاسم',
        roleInCase: 'الصفة',
        replyNoteRequestDate: 'تاريخ إيداع المذكرة',
        requestText: 'نص المذكرة',
        prosecutionNotes: 'مذكرات المدعي',
        defenseNotes: 'مذكرات المدعى عليه',
        removeFileDataAttachmentMessage: 'هل أنت متأكد من حذف المرفق؟',
        requestAdded: 'تم إضافة الطلب بنجاح',
      },
    },
    decision: {
      decisionInfoModalTitle: ':نص القرار',
      showPdf: 'عرض ملف القرار',
      pdf: 'ملف القرار',
      decisionText: 'القرار',
      caseDecisionNoData: 'لا يوجد بيانات لعرضها',
    },
    cards: {
      procedure: {
        codeDisplayName: 'رقم الاجراء',
        statusDisplayName: 'حالة الاجراء',
        dateDisplayName: 'تاريخ الاجراء',
      },
      decision: {
        header: 'القرار',
        codeDisplayName: 'رقم القرار',
        statusDisplayName: 'حالة القرار',
        typeDisplayName: 'نوع القرار',
        dateDisplayName: 'تاريخ القرار',
        resultDisplayName: 'نتيجة',
      },
      judgement: {
        header: 'الحكم',
        codeDisplayName: 'رقم الصك',
        statusDisplayName: 'صفة الحكم',
        typeDisplayName: 'حالة الصك',
        dateDisplayName: 'تاريخ صك الحكم',
        dueDateDisplayName: ' انتهاء المدة الاعتراضية',
        objectionRequestExists: 'يوجد طلب اعتراض على الحكم برقم ',
        notExecutable: 'لا يمكن تنفيذ الحكم حتى انتهاء المدة الاعتراضية للحكم',
        execution: {
          newRequest: 'تقديم طلب تنفيذ',
          myRequests: 'طلباتي',
          requestTitle: 'طلب التنفيذ',
          requester: 'طالب التنفيذ',
          respondent: 'المنفذ ضده',
          bankInfo: 'المعلومات البنكية',
          bankName: 'اسم البنك',
          ibanNumber: 'رقم الآيبان',
          ibanNote: 'يجب أن يكون الآيبان مسجل باسم وهوية صاحب الحساب',
          ibanPlaceHolder: 'رقم الآيبان SA ',
          startExecution: 'بدء التنفيذ',
          requestNo: 'رقم الطلب',
          partyName: 'اسم الطرف',
          requestDate: 'تاريخ الطلب',
          executeRequest: 'تنفيذ الطلب',
          close: 'إغلاق',
          requestList: 'قائمة الطلبات',
          requestSentSuccessfully: 'تم إنشاء طلب التنفيذ بنجاح. رقم الطلب  $$$$. لمتابعة حالة الطلب يرجى التوجه إلى تبويب التنفيذ',
          requestDetailsOnExecutionTab: 'لمتابعة حالة الطلبات، يرجى التوجه الى تبويب ',
          execution: 'التنفيذ',
          dueAmount: 'مبلغ المطالبة',
        },
      },
      request: {
        header: 'الطلب',
        codeDisplayName: 'رقم الطلب',
        statusDisplayName: 'حالة الطلب',
        typeDisplayName: 'نوع الطلب',
        dateDisplayName: 'تاريخ الطلب',
      },
      session: {
        header: 'الجلسة',
        codeDisplayName: 'الية الانعقاد ',
        statusDisplayName: 'حالة الجلسة',
        typeDisplayName: 'نوع الجلسة',
        dateDisplayName: 'تاريخ الجلسة',
        attest: 'اعتماد الضبط',
        attestationSuccessfully: 'تمت المصادقة على ضبط الجلسة بنجاح',
        attestationFailed: 'عفواً، للمصادقة يرجى الاختيار',
        attestationDone: 'تم المصادقة مسبقًا',
        selectToAttest: '<div class="ivu-notice-title"><p style="font-weight:800; font-size:18px"> يرجى الاختيار للمصادقة على ضبط الجلسة </p> <br><p style="font-weight:400;"> اختيار موافق او غير موافق للمصادقة اسفل الضبط</p></div>',
        show: 'عرض',
        timeDisplayName: 'وقت الجلسة',
        attestationNote: 'في حال عدم المصادقة قبل نهاية تاريخ اليوم',
        attestationRule: 'سيتم تطبيق ما ورد في المادة ٧١ من نظام المرافعات الشرعية',
        agreementAttestationRule: 'في حالة المصادقة علي المحضر سيكون الحكم نهائياً, وفقا للمادة 70\\3 من اللوائح التنفيذية لنظام المرافعات الشرعي.',
      },
      sessionTypes: {
        attendance: 'حضوري',
        videoSession: 'عن بعد',
        chatSession: 'كتابية',
      },
      lawsuitCaseReply: {
        header: 'مذكرة الدفاع الأولى',
        applicantName: 'المدعى عليه',
        identityNumber: 'رقم الهوية',
        dateDisplayName: 'تاريخ الرد',
      },
      document: {
        header: 'المرفق',
        typeDisplayName: 'نوع المرفق',
        dateDisplayName: 'تاريخ المرفق',
        attachmentName: 'اسم المرفق',
      },
      suspension: {
        header: 'تعليق مطالبات',
        typeDisplayName: 'نوع التعليق',
        activeStatus: 'سارية',
        inactiveStatus: 'غير سارية',
        dateDisplayName: 'تاريخ التعليق',
        stopSuspensionDateDisplayName: 'تاريخ إيقاف التعليق',
        concernedParty: 'الطرف المعني',
      },
    },
    fees: {
      title: 'تفاصيل التكاليف القضائية',
      noFees: 'غير خاضع للتكاليف القضائية',
    },
    lawsuitReplyForm: {
      defendantResponseTitle: 'رد المدعى عليه على الدعوى',
      selectPartiesToRespond: 'إختيار الاطراف المراد الرد عنهم',
      requestsAnswers: 'الإجابة على الطلبات',
      defendantAdditionalRequirement: 'إضافات و طلبات المدعى عليه',
      requestQuestionFirstSection: 'المعلومات المتعلقة بطلب المدعي',
      correctPart: 'الجزء الصحيح',
      infoCorrection: 'تصحيح المعلومات',
      agreeOrNotAgreeQuestion: 'هل انت موافق على',
      theCondition: 'الشرط',
      reasonNotToAgree: 'سبب عدم الموافقة',
      others: 'أخرى',
      newRequirementQuestion: 'هل لديك إضافة؟',
      newRequirement: 'الإضافة',
      newRequestQuestion: 'هل لديك طلبات؟',
      newRequest: 'الطلب',
      agree: 'موافق',
      notAgree: 'غير موافق',
      conditionallyAgree: 'موافق بشرط',
      hasAdditionalRequirement: 'لدي إضافة',
      hasNotAdditionalRequirement: 'ليس لدي إضافة',
      hasAdditionalRequests: 'لدي طلبات',
      hasNotAdditionalRequests: 'ليس لدي طلبات',
      correct: 'صحيح',
      inCorrect: 'غير صحيح',
      partiallyCorrect: 'صحيح جزئياً',
      noAnswer: 'لا أعلم',
      replyToLawsuit: 'مذكرة الدفاع الأولى',
      newReply: 'مذكرة جديدة',
      lawsuitReplyFormInfoModalTitle: 'عرض مذكرة الدفاع الأولى',
      lawsuitReplyFormNoData: 'لا يوجد بيانات لمذكرة الدفاع الأولى',
      applicantInfo: {
        title: 'بيانات مقدم الإجابة',
        name: 'مقدم الإجابة',
        identityNumber: 'رقم الهوية',
        roleIncase: 'صفته',
        onBehalfOfDefendant: 'بالنيابة عن مدعى عليه',
      },
      canNotAddReplyAsCaseHasJudgements: 'لا يمكن الرد على الدعوى بعد صدور الحكم',
      confirmationSendReply: 'تأكيد ارسال نموذج مذكرة الدفاع الأولى للدائرة القضائية',
      sendReplyConfirmationMessage: 'هل انت متأكد من ارسال نموذج مذكرة الدفاع الأولى للدائرة القضائية؟',
      replySentSuccessfully: 'تم ارسال نموذج مذكرة الدفاع الأولى للدائرة القضائية بنجاح',
      missingFieldsErrorMessage: 'عفواً، ،يرجى إكمال البيانات الإلزامية',
    },
    caseProofs: 'أسانيد الدعوى',
    noCaseProofs: 'لا يوجد أسانيد',
    caseSubject: 'موضوع الدعوى',
    noCaseSubject: 'لا يوجد موضوع',
    caseDemands: 'طلبات المدعي',
    noCaseDemands: 'لا يوجد طلبات',
    archiveTheCase: {
      archive: 'ارشفة القضية',
      cancelArchiving: 'الغاء ارشفة القضية',
      title: 'عند أرشفتك للقضية، يجب مراعاة الجوانب التالية:',
      hiddenCase: '1.عند أرشفة القضية سيتم إخفاؤها من قائمة القضايا.',
      keepCaseCode: '2.يجب الاحتفاظ برقم القضية للوصول إليها مره أخرى.',
      accessCaseBySearch: '3.الوصول للقضية يكون من خلال البحث برقم القضية.',
      cancelArchive: '4.إلغاء ارشفة القضية، يكون عبر البحث برقم القضية وإلغاء أرشفة القضية.',
      unarchiveTitle: 'تعليمات إلغاء أرشفة القضية',
      showCase: '- عند إلغاء أرشفة القضية سيتم إظهار تفاصيل القضية ضمن القضايا',
    },
    archivingTheCaseForNonOriginalParties: {
      archive: 'ارشفة القضية',
      cancelArchiving: 'الغاء ارشفة القضية',
      title: 'عند أرشفتك للقضية، يجب مراعاة الجوانب التالية:',
      hiddenCase: '1.عند أرشفة القضية سيتم إخفاؤها من قائمة القضايا وإظهارها في تبويب القضايا المؤرشفة.',
      accessCase: '2.للوصول للقضية يكون من خلال الدخول على تبويب القضايا المؤرشفة.',
      openArchiveCaseTab: '3.الدخول على تبويب القضايا المؤرشفة يتطلب رمز تحقق',
      cancelArchive: '4.إلغاء ارشفة القضية، يكون عبر الدخول على تبويب القضايا المؤرشفة وإلغاء الارشفة برمز التحقق.',
      unarchiveTitle: 'تعليمات إلغاء أرشفة القضية',
      showCase: ' - عند إلغاء أرشفة القضية سيتم إظهار تفاصيل القضية ضمن القضايا',
    },
  },
  calendar: {
    showSessionDetails: 'عرض تفاصيل الجلسة',
    day: 'يومي',
    sessions: 'الجلسات',
    caseCode: 'قضية رقم',
    week: 'اسبوعي',
    sessionType: 'نوع الجلسة',
    month: 'شهري',
    more: 'المزيد',
    today: 'اليوم',
    min: 'دقيقة',
    am: 'صباحًا',
    pm: 'مساء',
    amShort: 'ص',
    pmShort: 'م',
  },
  judicialFees: {
    filterWithInvoiceNo: 'البحث برقم السند',
    filterWithDeceasedSocialId: 'رقم هوية المتوفى',
    deceasedSearchAlertInfo: 'هذه الخدمة تتيح للأفراد الاستعلام عن سندات التكاليف القضائية لمورث',
    invoiceNo: 'رقم السند',
    bill: 'السند',
    details: 'تفاصيل',
    billStatus: 'حالة السند',
    provider: 'المُسند',
    billFeeObjection: 'الإعتراض على سند التكاليف',
    billFeeDetails: 'تفاصيل تكلفة الطلبات',
    billRefundDetails: {
      title: 'تفاصيل الاسترداد',
      totalAmount: 'اجمالي قيمة السند',
      amount: 'المبلغ المدفوع',
      refundedAmount: 'المبلغ المسترد',
      refundedDate: 'تاريخ الاسترداد',
    },
    billUpdateDetails: {
      title: 'تفاصيل التعديل',
      currentAmount: 'المبلغ بعد التعديل',
      originalAmount: 'قيمة الفاتورة',
      updateDate: 'تاريخ التعديل',
    },
    billDetails: 'تفاصيل السند',
    billTimeline: 'الخط الزمني للسند',
    clickHere: 'إضغط هنا',
    sar: '\uE900',
    objectionRequestSuccessMessage: 'تم ارسال طلب إعتراض بنجاح',
    attachments: 'المرفقات',
    objectionRequest: 'طلب إعتراض',
    billObjectionRequest: 'إعتراض على السند',
    objectionTitle: 'الإعتراض على سند التكاليف',
    dearCustomer: 'عزيزي المستفيد',
    objectionHeader: 'يمكنكم تقديم طلب إعتراض على  سند التكاليف القضائية عبر الضغط على ايقونة "إعتراض على السند"',
    objectionDueDateHeader: 'لا يمكن تقديم طلب إعتراض على سند التكاليف القضائية لانتهاء المهلة المحددة',
    paidBills: 'سندات تم سدادها',
    notPaidBills: 'سندات لم يتم سدادها',
    heirsListing: 'الاستعلام عن التكاليف القضائية',
    submitObjection: 'تقديم إعتراض',
    objectionReasons: 'أسباب الإعتراض',
    objectionDetails: 'تفاصيل الإعتراض',
    oTherObjectionReason: 'سبب الإعتراض',
    confirmationTitle: 'تأكيد الحفظ',
    confirmationMessage: 'هل تريد تأكيد طلب الإعتراض',
    attachmentValidationMessage: 'يجب ارفاق مرفق واحد بحد ادنى ومرفقين بحد اقصى',
    billInvoice: 'طباعة الفاتورة',
    providerName: 'تصنيف السند',
    identityNumber: 'هوية المكلف بالسداد',
    customerName: 'المكلف بالسداد',
    billNumber: 'رقم فاتورة سداد',
    billedNo: 'رقم المفوتر',
    amount: 'قيمة الفاتورة',
    creationDate: 'تاريخ إصدار الفاتورة',
    expiryDate: 'تاريخ الانتهاء',
    statusName: 'حالة الفاتورة',
    productName: 'اسم الطلب',
    providerItemCode: 'رقم الطلب',
    itemTypeName: 'نوع الطلب',
    generalDetails: 'تفاصيل عامة',
    summaryRequests: 'ملخص الطلبات',
    totalAmount: 'إجمالي التكلفة',
    print: 'طباعة',
    sequence: 'رقم تسلسلي',
    saudi: 'سعودي',
    cost: 'التكلفة',
    other: 'أخرى',
    filter: {
      billStatus: 'حالة السند',
      provider: 'المُسند',
      fromDate: 'التاريخ من',
      toDate: 'التاريخ الى',
    },
    billDetailsHeader: {
      execProduct: 'السند',
      icmsProduct: 'الطلب',
      typeName: 'نوع',
      billedAmount: 'المبلغ المستحق',
      percentage: 'النسبة',
      sharePercentage: 'نسبة التحمل',
      amountInSAR: 'التكلفة بالريال',
      providerItemCode: 'رقم الطلب',
    },
    attributes: {
      caseCode: 'رقم القضية',
      sakCode: 'رقم السند التنفيذي',
      caseType: 'النوع',
      classification: 'التصنيف',
      courtName: 'المحكمة',
      circle: 'الدائرة',
    },
    headers: {
      invoiceNo: 'رقم سداد السند',
      billStatusName: 'حالة السند',
      creationDate: 'تاريخ الإنشاء',
      expiryDate: 'الدفع قبل تاريخ',
      lastObjectionDate: 'المدة المتبقية للإعتراض',
      provider: 'المُسند',
      objectionStatus: 'حالة الإعتراض',
      day: 'يوم',
      customerName: 'المكلف بالسداد',
      identityNumber: 'رقم الهوية',
      amount: 'قيمة السند',
    },
    objection: {
      title: 'الإعتراض على سند التكاليف',
      status: 'حالة الإعتراض',
      code: 'رقم الإعتراض',
      reasonText: 'نص الإعتراض',
      reason: 'سبب الإعتراض',
      attachments: 'المرفقات',
      noAttachments: 'لا يوجد مرفقات',
      customer: 'مقدم الإعتراض',
      details: 'تفاصيل الإعتراض',
      notes: 'ملاحظات لجنة الاعتراض',
      decision: 'قرار لجنة الاعتراض',
      decisionAttachment: 'عرض القرار',
      creationDate: 'تاريخ الاعتراض',
    },
    requestsFeesEstimation: {
      judicialFessExceptionInfo: 'يستثنى من دفع التكاليف القضائية بعد صدور الحكم النهائي الفئات التالية:( مسجون في قضية مالية، عامل في حالة المطالبة بالمستحقات الناشئة عن العقد، وزارة أو جهة حكومية، مستفيدي الضمان الاجتماعي)',
      title: 'حاسبة التكاليف القضائية التقديرية',
      requestName: 'الطلب',
      amountInSAR: 'التكلفة بالريال',
      confirmationMessage: 'تم الاطلاع على التكلفة القضائية حسب التقدير المبدئي للطلبات المقدمة',
      submit: 'تقديم',
      pledgeErrorText: 'الاختيار مطلوب',
      zeroAmountFees: 'غير خاضع للتكاليف القضائية',
    },
  },
  bankruptcy: {
    bankruptcy: 'الإفلاس',
    pledge: {
      title: 'التعهد',
      pledgeLabel: 'أتعهد بتدوين جميع البيانات بالشكل الصحيح ومن واقع الهويات والسجلات والمستندات، وأتحمل كامل المسؤولية إذا ثبت خلاف ذلك و أقر بأني اطلعت على المواد النظامية ذات العلاقة بافتتاح الإجراء من نظام الإفلاس ولائحته التنفيذية والقواعد والقرارات ذات العلاقة',
      pledgeErrorText: 'الرجاء الموافقة على التعهد',
    },
    hint: {
      section1Title: 'وصف الخدمة',
      section1: 'تتيح الخدمة لمقدم الطلب تقديم طلب افتتاح إجراء من إجراءات الإفلاس الكترونياً وفقاً للإجراءات المنصوص عليها في نظام الإفلاس ولائحته التنفيذية، والقواعد المرسومة في الخدمة وذلك دون الحاجة لمراجعة المحكمة حتى موعد الجلسة الأولى',
      section2Title: 'التلميحات',
      section2_1: 'أتعهد بتدوين جميع البيانات بالشكل الصحيح ومن واقع الهويات والسجلات والمستندات، وأتحمل كامل المسؤولية إذا ثبت خلاف ذلك.',
      section2_2: 'أقر بأني اطلعت على المواد النظامية ذات العلاقة بافتتاح الإجراء من نظام الإفلاس ولائحته التنفيذية والقواعد والقرارات ذات العلاقة.',
      section2_3: 'أعلم أن الطلب لا يقبل إلا بعد استيفاء متطلباته النظامية ومن ذلك: ',
      section2_3_1: 'استكمال بيانات الطلب',
      section2_3_2: '‌تدوين عنوان واضح للمدين',
      section2_3_3: 'إرفاق الوثائق اللازمة الموضحة في صفحة المرفقات، مثل سند الصفة (الوكالة) وصورة الهوية لمقدم الطلب، وعقد تأسيس الشركة والسجل التجاري',
      section2_3_4: 'إرفاق المستندات المؤيدة للطلب',
      section2_3_5: 'إرفاق المعلومات والوثائق المنصوص عليها في لائحة تحديد المعلومات والوثائق المنصوص عليها في نظام الإفلاس ولائحته التنفيذية',
      section2_4: 'يجب أن يكون مقدم الطلب محام ولديه وكالة ورخصة محاماة سارية، أو ممثل الجهة الإدارية أو موظف الادارة القانونية للشخصية الاعتبارية الخاصة إذا كانوا مرخصين من الوزارة.',
      section3Title: 'المرفقات المطلوبة',
      section3_1: 'نسخة من هوية المدين إذا كان شخصًا طبيعيًا أو مؤسسة.',
      section3_2: 'نسخة من السجل التجاري إذا كان مؤسسة أو شركة.',
      section3_3: 'نسخة من عقد التأسيس أو النظام الأساسي وتعديلاتها، إذا كان المدين شركة.',
      section3_4: 'نسخة من ترخيص ممارسة النشاط، إن وجد.',
      section3_5: 'نسخة من سند صفة الممثل أو الوكيل، إن وجد.',
      section3_6: 'قرار موافقة الجهة المختصة على قيد طلب افتتاح إجراء الإفلاس أو الإيداع القضائي للمدين، إذا كان كيانًا منظمًا، أو ما يثبت تقديم طلب الموافقة ومضي المدة المحددة دون صدور القرار وفق حكم الفقرة (3) من المادة (الثالثة) من النظام.',
      section3_7: 'ما يثبت كون المدين مفلسًا أو متعثرًا أو يخشى تعثره -بحسب الأحوال-.',
      section3_8: 'إذا كان الطلب مقدمًا لافتتاح إجراء التسوية الوقائية؛ فيرفق المدين إقرارًا منه بعدم خضوعه لإجراء التسوية الوقائية أو إجراء التسوية الوقائية لصغار المدينين خلال (الاثني عشر) شهرًا السابقة لهذا الطلب، وإفادة من سجل الإفلاس بذلك، والمقترح مؤشرًا عليه من أمين مدرج في قائمة الأمناء باستيفائه المعلومات والوثائق المطلوبة.',
      section3_9: 'إذا كان الطلب مقدمًا لافتتاح إجراء إعادة التنظيم المالي؛ فيرفق المدين إقرارًا منه بعدم خضوعه لإجراء إعادة التنظيم المالي أو إجراء إعادة التنظيم المالي لصغار المدينين خلال (الاثني عشر) شهرًا السابقة لهذا الطلب، وإفادة من سجل الإفلاس بذلك.',
      section3_10: 'إذا كان الطلب مقدمًا لافتتاح إجراء التصفية الإدارية؛ فيرفق المدين ما يفيد أن حصيلة بيع أصول التفليسة غير كافية للوفاء بمصروفات إجراء التصفية أو إجراء التصفية لصغار المدينين.',
      section3_11: 'إذا كان الطلب إيداعًا قضائيًا؛ فيرفق الأمين ما ورد في المادة (الثالثة عشرة) من لائحة المعلومات والوثائق.',
      section3_12: 'يجب أن تقدم القوائم المالية خلال 24 شهر المادة (الرابعة) من لائحة المعلومات والوثائق.',
    },
    actions: {
      mainRequestCategories: 'أنواع الطلبات',
      requestOwnerTypes: 'أنواع المدينين',
      stakeholderTypes: 'أنواع اصحاب المصلحة',
      legalCapacities: 'صفات مقدم الطلب',
      commercialCourts: 'المحاكم التجارية',
      procedureTypes: 'تصنيفات الطلبات',
      mainRequestStatuses: 'حالات الطلبات',
      identityTypes: 'أنواع الهويات',
      partyTypes: 'الصفات',
      debtorClassifications: 'أنواع المدينين',
      firmTypes: 'أنواع الشركات',
      organizedEntityTypes: 'أنواع الكيانات',
      assetTypes: 'أنواع الأصول',
      realEstateTypes: 'أنواع العقارات',
      currencies: 'العملات',
      globalAttachmentType: 'أنواع المرفق العامة',
      attachmentType: 'أنواع المرفق',
      countries: 'الدول',
      regions: 'المناطق',
      cities: 'المدن',
      countryCities: 'المدن',
    },
    common: {
      creditor: 'دائن',
      debtor: 'مدين',
      theCreditor: 'الدائن',
      theDebtor: 'المدين',
      person: 'فرد',
      firm: 'شركة',
      organization: 'مؤسسة',
      nationalId: 'هوية وطنية',
      regularResidency: 'إقامة نظامية',
      tempResidency: 'إقامة مؤقته',
      passport: 'جواز سفر',
      gulfCountry: 'هوية وطنية خليجية',
      travelAndWorkCard: 'بطاقة تنقل وعمل',
      visitor: 'هوية زائر',
      identityOfMotamer: 'هوية معتمر',
      savedSuccessfully: 'تم الحفظ بنجاح',
      addedSuccessfully: 'تمت الإضافة بنجاح',
      updateSuccessfully: 'تم التعديل بنجاح',
      sendSuccessfully: 'تم إرسال الطلب بنجاح',
      removeSuccessfully: 'تم الحذف بنجاح',
      validateSuccessfully: 'تم التحقق بنجاح',
      informationDebt: 'معلومات عن الدين',
      government: 'جهة حكومية',
      foreignCompany: 'شركة أو مؤسسة أجنبية',
      cancel: 'إلغاء',
      mainRequest: 'طلب رئيسي',
      subRequest: 'طلب فرعي',
    },
    debtorForm: {
      debtor: 'المدين',
      title: 'بيانات المدين',
      debtorName: 'اسم المدين',
      firmType: 'نوع الشركة',
      commercialRegistrationNumber: 'السجل التجاري',
      unifiedNumber: 'الرقم الموحد',
      city: 'المدينة',
      region: 'المنطقة',
      headquarter: 'المقر الرئيسي',
      mobile: 'رقم الجوال',
      email: 'البريد الالكتروني',
      phone: 'رقم الهاتف',
      classification: 'صفة المدين',
      isOrganizedEntity: 'هل المدين من الكيانات المنظمة',
      organizedType: 'نوع الكيان',
      otherOrganizedType: 'نوع الكيان الاخر',
      isSpecifiedOrganization: 'هل يوجد قرار موافقة من الجهة المختصة',
      specifiedOrganizationName: 'اسم الجهة المختصة',
      specifiedOrganizationUnifiedNumber: 'الرقم الموحد للجهة المختصة',
      bankruptcyProofs: 'مايثبت كون المدين مفلسا أو متعثراً أو يخشى تعثره',
      liquidationBankruptcyProofs: 'ما يثبت كون المدين مفلسًا أو متعثرًا',
      invalidNumber: 'الرقم الموحد غير صحيح',
      organizationName: 'اسم الجهة',
    },
    creditorForm: {
      creditor: 'الدائن',
      title: 'بيانات الدائن',
      fullName: 'الاسم كاملاً',
      dueDate: 'موعد الوفاء به',
      debtValue: 'قيمة الدين',
      debtOrigin: 'منشأ الدين',
      paymentStatus: 'حالة السداد',
      receivedPayment: 'الدفعة المستلمة',
      remainingPayment: 'الدفعة المتبقية',
    },
    identityVerificationForm: {
      partyType: 'نوع',
      identityTypeId: 'نوع الهوية',
      identityTypeIdForPerson: 'نوع هوية',
      identityNumber: 'رقم الهوية',
      identityNumberForPeron: 'رقم هوية',
      dateOfBirth: 'تاريخ الميلاد',
      dateOfBirthForPeron: 'تاريخ ميلاد',
      name: 'اسم',
      firstName: 'الاسم الأول',
      fatherName: 'اسم الأب',
      thirdName: 'اسم الجد',
      familyName: 'اسم العائلة',
      fullName: 'الاسم كامل',
      theName: 'الاسم',
      commercialRegistrationNumber: 'السجل التجاري',
      commercialRegistrationNumberOrUnifiedNumber: 'رقم السجل التجاري/الرقم الوطني الموحد',
      unifiedNumber: 'الرقم الوطني الموحد',
      managerFullName: 'صاحب المؤسسة',
      managerIdentityNumber: 'هوية صاحب المؤسسة',
      firmManagerIdentityNumber: 'هوية مدير الشركة',
      cannotAddRequestApplicantAsManager: 'لا يمكن إضافة مقدم الطلب الرئيسيى كمدير لشركة أجنبية',
      validateIdentityNumber: 'التحقق',
      personVerify: 'يتم التحقق من الهوية عن طريق (إدخال رقم الهوية وتاريخ الميلاد) أو (رقم الهوية والاسم الأول)',
      nonPersonVerify: 'يتم التحقق عن طريق إدخال الرقم الوطني الموحد',
      countryId: 'الدولة',
      cityId: 'المدينة',
      regionId: 'المنطقة',
      companyName: 'اسم الشركة',
      governmentAgencyName: 'اسم الجهة الحكومية',
      interestTypeLabel: 'تحديد نوع ذو المصلحة',
    },
    activitiesForm: {
      title: 'نبذة عن النشاط',
      activities: 'طبيعة النشاط',
      activitiesStatus: 'حالة النشاط',
      activitiesStartDate: 'تاريخ بداية النشاط',
      activitiesEndDate: 'تاريخ توقف النشاط',
      numberBranches: 'عدد الفروع',
      capital: 'رأس المال',
      numberCreditors: 'عدد الدائنين',
      totalDebt: 'إجمالي قيمة الديون',
      numberDebtors: 'عدد المدينين',
      totalRights: 'إجمالي قيمة الحقوق',
      numberEmployees: 'عدد العاملين',
      totalAsset: 'إجمالي قيمة الأصول',
      moneyStoragePlace: 'مكان حفظ الأصول',
      proofDebtorBankruptcy: 'ما يثبت كون المدين مفلس أو متعثر أو يخشى تعثره - بحسب الأحوال-',
      overviewDebtorFinancialPosition: 'نبذه عن الوضع المالي للمدين خلال 24 شهر السابقة وتأثيرات الوضع الاقتصادي عليه',
      active: 'ساري',
      inActive: 'غير ساري',
    },
    requestDetails: {
      title: 'القوائم المطلوب إضافتها للطلب',
      list: 'قائمة',
      importData: 'استيراد البيانات',
      sequence: 'الرقم التسلسلي',
      auditConfirmations: {
        'flag_1': 'تم التأكد من صحة البيانات الأساسية للطلب',
        'flag_2': 'تم التأكد من صحة اختيار المحكمة المختصة',
        'flag_3': 'تم التأكد من صحة واكتمال بيانات مقدم الطلب',
        'flag_4': 'تم التأكد من صحة واكتمال بيانات المدين',
        'flag_5': 'تم التأكد من صحة واكتمال بيانات النشاط الأساسية',
        'flag_6': 'تم التأكد من صحة ما يثبت كون المدين مفلساً أو متعثراً أو يخشى تعثره',
        'flag_7': 'تم التأكد من صحة الوضع المالي للمدين خلال 24 شهر السابقة وتأثيرات الوضع الاقتصادي عليه',
        'flag_8': 'تم التأكد من صحة واكتمال بيانات الأمين المرشح',
        'flag_9': 'تم التأكد من صحة بيانات الديون في ذمة المدين',
        'flag_10': 'تم التأكد من صحة بيانات الديون المستحقة للمدين',
        'flag_11': 'تم التأكد من صحة بيانات فروع المدين',
        'flag_12': 'تم التأكد من صحة بيانات أصول المدين',
        'flag_13': 'تم التأكد من صحة بيانات العاملين لدى المدين',
        'flag_14': 'تم التأكد من صحة بيانات شركاء المدين',
        'flag_15': 'تم التأكد من صحة واكتمال بيانات الدائن',
        'flag_16': 'تم التأكد من صحة واكتمال بيانات الطلبات والقضايا المرتبطة',
        'flag_17': 'تم التأكد من صحة بيانات الوكالة',
      },
      partners: {
        tabTitle: 'الشركاء',
        partner: 'شريك',
        thePartner: 'الشريك',
        share: 'قيمة الحصة',
        commercialRegistrationNumber: 'السجل التجاري',
        organizationName: 'اسم الشركة / المؤسسة',
        identityType: 'نوع الهوية',
        identityNumber: 'رقم الهوية',
        dateOfBirth: 'تاريخ الميلاد',
        managerName: 'إسم المدير',
        partnerName: 'إسم الشريك',
      },
      interestParty: { tabTitle: 'ذو المصلحة' },
      branches: {
        tabTitle: 'الفروع',
        branch: 'فرع',
        theBranch: 'الفرع',
        commercialRegisterNo: 'السجل التجاري',
        unifiedNumber: 'الرقم الموحد',
      },
      bankruptDebts: {
        totalCount: 'إجمالي عدد الدائنين',
        theBankruptDebt: 'الدائن',
        bankruptDebtName: 'إسم الدائن',
        note: 'يجب على الأقل إضافة دين واحد من الديون في ذمة المدين',
        tabTitle: 'الديون في ذمة المدين',
        bankruptDebt: 'دين في ذمة المدين',
        debtValue: 'قيمة الدين',
        dueDate: 'موعد الوفاء به',
        debtOrigin: 'منشأ الدين',
        countryId: 'الدولة',
        cityId: 'المدينة',
        mobile: 'الهاتف الجوال',
        email: 'البريد الإلكتروني',
        creditorClassificationId: 'صفة الدائن',
        otherCreditorClassification: 'صفة الدائن الاخرى',
        isGuaranteed: 'هل الدين مضمون',
        guaranteeType: 'نوع الضمان',
        paymentStatusId: 'حالة السداد',
        receivedPayment: 'الدفعة المستلمة',
        remainingPayment: 'الدفعة المتبقية',
        totalCountDebt: 'إجمالي قيمة الديون',
        totalCountDebtGuaranteed: 'إجمالي قيمة الديون المضمونة',
        invalidDebtAmount: 'مجموع الدفعة المتبقية و الدفعة المستحقة يجب أن يساوي قيمةالدين ',
        invalidDebtAmountValue: 'يجب الا يقل قيمة الدين عن 50 ألف كما هو محدد بلجنة الإفلاس',
        name: 'اسم الدائن',
        identityType: 'نوع الهوية',
        identityNumber: 'رقم الهوية',
        dueDateGregorian: 'موعد الوفاء به ميلادي',
        dueDateHijri: 'موعد الوفاء به هجري',
        dateOfBirth: 'تاريخ الميلاد',
        commercialRegistrationNumber: 'السجل التجاري',
        unifiedNumber: 'الرقم الموحد',
        managerFullName: 'صاحب الشركة أو المؤسسة',
      },
      debtorAssets: {
        totalCount: 'إجمالي الأصول',
        totalSum: 'إجمالي قيمة الأصول',
        tabTitle: 'أصول المدين',
        debtorAsset: 'أصل للمدين',
        assetType: 'نوع الأصل',
        assetValue: 'قيمة الأصل',
        bankName: 'اسم البنك',
        iBAN: 'رقم الايبان',
        accountBalance: 'رصيد الحساب',
        portfolioNumber: 'رقم المحفظة',
        organizationName: 'اسم الجهة',
        portfolioValue: 'قيمة المحفظة',
        realEstateType: 'نوع العقار',
        otherRealEstateType: 'نـوع العقار',
        judgementCode: 'رقم الصك',
        judgementDate: 'تاريخ الصك',
        assetLocation: 'الموقع',
        vehicleType: 'نوع المركبة',
        purchaseYear: 'سنة الشراء (هجري)',
        transportedType: 'نوع المنقول',
      },
      bankruptDueRights: {
        tabTitle: 'الديون المستحقة للمدين',
        bankruptDueRight: 'دين مستحق للمدين',
        debtValue: 'قيمة الدين',
        dueDate: 'موعد الاستحقاق',
        debtOrigin: 'منشأ الدين',
        countryId: 'الدولة',
        cityId: 'المدينة',
        mobile: 'الهاتف الجوال',
        email: 'البريد الإلكتروني',
        isGuaranteed: 'هل الدين مضمون',
        guaranteeType: 'نوع الضمان',
        name: 'اسم المدين',
        identityNumber: 'رقم الهوية',
        Guaranteed: 'نوع الدين',
        identityType: 'نوع الهوية',
        dueDateGregorian: 'موعد الاستحقاق ميلادي',
        dueDateHijri: 'موعد الاستحقاق هجري',
        dateOfBirth: 'تاريخ الميلاد',
        commercialRegistrationNumber: 'السجل التجاري',
        unifiedNumber: 'الرقم الموحد',
        managerFullName: 'صاحب الشركة أو المؤسسة',

      },
      debtorEmployees: {
        totalCount: 'إجمالي عدد العاملين',
        totalSum: 'إجمالي قيمة المستحقات للعاملين لدى المدين',
        tabTitle: 'العاملين لدى المدين',
        debtorEmployee: 'عامل لدى المدين',
        debtorEmployeeName: 'إسم العامل',
        theEmployee: 'العامل',
        nationality: 'الجنسية',
        mobile: 'الهاتف الجوال',
        email: 'البريد الإلكتروني',
        salaryPerMonth: 'الأجر الشهري',
        currency: 'العملة',
        duesValue: 'قيمة المستحقات',
        duesDescription: 'وصف المستحقات',
        identityType: 'نوع الهوية',
        identityNumber: 'رقم الهوية',
        dateOfBirth: 'تاريخ الميلاد',
      },
    },
    requestAttachments: { title: 'المرفقات المطلوب إضافتها للطلب' },
    incompleteReasons: {
      title: 'أسباب عدم الاكتمال',
      nots: 'ملاحظات التدقيق',
      messageIncompleteReasons: 'يرجى استكمال وتصحيح البيانات التي لم يتم التأكد من صحتها',
    },
    basicDataDetails: {
      title: 'البيانات الأساسية المطلوبة لتقديم طلب فتح إجراء إفلاس',
      mainRequestType: 'نوع الطلب',
      requestOwnerType: 'نيابة عن',
      legalCapacity: 'نوع مقدم الطلب',
      commercialCourt: 'المحكمة',
      requestReason: 'سبب تقديم الطلب',
      procedureType: 'تصنيف الطلب',
      procedureTypeOpen: 'نوع الطلب(إفتتاح)',
      procedureTypeDeposit: 'نوع الطلب(إيداع)',
    },
    addAttachment: 'إضافة مرفق',
    home: {
      lawyerNotificationMessage: 'للوصول إلى طلبات الإفلاس بصفة محامي، الرجاء الدخول عبر ناجز المحامين',
      filterWithRequestNo: 'البحث برقم الطلب',
      filterWithProcedureNo: 'البحث برقم الإجراء',
      tabs: {
        mainRequestsTab: 'طلبات افتتاح إجراءات الإفلاس',
        myRequestsTab: 'طلباتي',
      },
      filter: {
        fromDate: 'التاريخ من',
        toDate: 'التاريخ الى',
        mainRequestCategory: 'تصنيف الطلب',
        procedureType: 'نوع الاجراء',
        status: 'حاله الطلب',
        procedureName: 'نوع الطلب',
        procedureTypeName: 'نوع الإجراء',
        legalCapacityName: 'صفة مقدم الطلب',
        openedProcedureName: 'الإجراء المفتتح',
        subRequestTypeName: 'نوع الطلب',
        requestCode: 'رقم الطلب',
      },
      headers: {
        requestCode: 'رقم الطلب',
        mainRequestCode: 'رقم الطلب الرئيسي',
        subRequestCode: 'رقم الطلب الفرعي',
        requestTypeName: 'نوع الطلب',
        applicantRequestName: 'مقدم الطلب',
        procedureCode: 'رقم الإجراء',
        requestDate: 'تاريخ الطلب',
        procedureDate: 'تاريخ الإجراء',
        legalCapacityName: 'صفة مقدم الطلب',
        requestCategoryName: ' تصنيف الطلب',
        requestStatusName: 'حالة الطلب',
        onBehalfOf: 'نيابة عن',
        procedureName: 'نوع الطلب',
        openedProcedureName: 'الإجراء المفتتح',
        procedureStatus: 'حالة الإجراء',
        requestProcedureName: 'نوع الطلب المقدم',
        subRequestTypeName: 'اسم الطلب الفرعي',
      },
    },
    requestInfo: {
      requestCode: 'رقم الطلب: ',
      court: 'المحكمة: ',
      requestDate: 'التاريخ: ',
      status: 'حاله الطلب: ',
      requestType: 'نوع الطلب: ',
    },
    request: {
      tabs: {
        basicData: 'البيانات الاساسيه',
        requestApplicantData: 'بيانات المعني بالطلب',
        requestDetails: 'تفاصيل الطلب',
        requestAttachments: 'المرفقات',
        requestsAndRelatedCases: 'الطلبات والقضايا المرتبطة',
      },
    },
    attorneyTypes: {
      internal: 'وكالة داخلية',
      external: 'وكالة خارجية',
    },
    genders: {
      male: 'ذكر',
      female: 'أنثى',
    },
    countries: {
      sa: 'المملكة العربية السعودية',
      eg: 'جمهورية مصر العربية',
    },
    paymentStatus: {
      notPaid: 'لم يتم السداد',
      partiallyPaid: 'تم السداد بشكل جزئي',
    },
    creditorClassifications: {
      funding: 'جهة تمويلية',
      governmental: 'جهة حكومية',
      other: 'اخرى',
    },
    requestApplicant: {
      title: 'بيانات مقدم الطلب',
      personalInfo: 'البيانات الشخصية',
      mobileNumber: 'الهاتف الجوال',
      email: 'البريد الالكتروني',
      invalidNumber: 'رقم الترخيص غير صحيح',
      licenceNumber: 'رقم الترخيص',
      mojLicenceNumber: 'رقم ترخيص وزارة العدل',
      partyType: 'الصفة',
      socialIdType: 'نوع الهوية',
      socialId: 'رقم الهوية',
      birthDate: 'تاريخ الميلاد',
      firstName: 'الاسم الأول',
      fatherName: 'اسم الأب',
      thirdName: 'اسم الجد',
      familyName: 'اسم العائلة',
      fullName: 'الاسم الكامل',
      nationality: 'الجنسية',
      gender: 'النوع',
    },
    lawyerInfo: {
      invalidNumber: 'رقم الوكالة غير صحيح',
      title: 'بيانات الوكالة',
      attorneyType: 'نوع الوكالة',
      attorneyNumber: 'رقم الوكالة',
    },
    secretaryForm: {
      name: 'الأمين المرشح',
      title: 'بيانات الأمين المرشح',
      fullName: 'اسم الأمين كاملاً',
      socialId: 'رقم الهوية',
      licenceNumber: 'رقم الترخيص',
    },
    attorneyForm: {
      title: 'بيانات الوكالة',
      attorneyType: 'نوع الوكالة',
      attorneyNumber: 'رقم الوكالة',
      invalidNumber: 'رقم الوكالة غير صحيح',
      invalidNumberMessage: 'عفوا، رقم الوكالة غير صحيح',
      validate: 'التحقق',
      attorneyText: 'نص الوكالة',
    },
    requestReply: { send: 'إرسال' },
    bankruptcyFile: {
      request: 'طلب',
      requestCode: 'رقم الطلب',
      subRequestCode: 'رقم الطلب الفرعي',
      procedureCode: 'رقم الإجراء',
      requestDate: 'تاريخ الطلب',
      requestType: 'نوع الطلب',
      procedureDate: 'تاريخ الإجراء',
      legalCapacityName: 'مقدم الطلب',
      requestCategoryName: ' تصنيف الطلب',
      requestStatusName: 'حالة الطلب',
      bankruptName: 'اسم المدين',
      onBehalfOf: 'نيابة عن',
      procedureName: 'نوع الطلب',
      courtName: 'المحكمة',
      openedProcedureName: 'الإجراء المفتتح',
      openedProcedureDate: 'تاريخ الافتتاح',
      procedureStatus: 'حالة الإجراء',
      steps: {
        step1: 'مرحلة تقديم وتدقيق الطلب',
        step2: 'مرحلة النظر بالدائرة القضائية',
        step3: 'مرحلة افتتاح الإجراء',
      },
      basicInfo: {
        tabTitle: 'بيانات نموذج الطلب',
        requestApplicant: { title: 'بيانات مقدم الطلب' },
        requestOwner: { title: 'بيانات المعني بالطلب' },
        activities: { title: 'بيانات النشاط' },
        secretaryInfo: {
          title: 'بيانات أمين الإفلاس',
          secretaryApprovedInfo: 'بيانات الأمين المعين',
          name: 'اسم الأمين',
          identityNumber: 'رقم الهوية',
          role: 'الدور',
          headSecretaryBankruptcy: 'رئيس  أمناء الإفلاس',
          secretaryBankruptcy: 'أمين إفلاس',
          committeeBankruptcyInfo: 'بيانات لجنة الإفلاس',
          secretaryBankruptcyInfo: 'بيانات الأمين المرشح',
          secretaryBankruptcyName: 'الاسم',
          unifiedNumber: 'الرقم الوطني الموحد',
          status: 'الحالة',
          confirmed: 'معتمد',
          unConfirmed: 'غير معتمد',
        },
      },
      requestDetails: { tabTitle: 'تفاصيل الطلب' },
      sessions: {
        tabTitle: 'الجلسات',
        requestCircleSessions: 'جلسات الدائرة',
        requestElitigationSessions: 'جلسات التهيئة',
        elitigationSessions: {
          title: 'جلسة الترافع الإلكترونى للطلب رقم',
          myQuestions: 'الموجهة لي',
          allQuestions: 'جميع الأسئلة',
          questionsAndAnswers: 'الردود والأسئلة',
          bankruptcyPreparationDepartment: 'تهيئة وحدة الإفلاس',
          questionText: 'نص السؤال',
          lastReplyDate: 'آخر تاريخ للرد',
          cannotAttachFile: 'لا يمكن ارفاق ملفات',
          whoReplies: 'المعني بالرد',
          reply: 'الرد',
          send: 'إرسال',
          text: 'النص',
          day: 'يوم',
          days: 'أيام',
        },
      },
      judgements: { tabTitle: 'الأحكام' },
      requests: {
        tabTitle: 'الطلبات',
        verdictObjectionRequest: { verdictObjection: 'اعتراض على حكم' },
        agreeOnTermsAndConditions: 'اتعهد بتدوين جميع البيانات بالشكل الصحيح حسب الوثائق الرسمية وأتحمل كامل المسئولية اذا ثبت خلاف ذلك',
        viewSubRequest: 'عرض الطلب',
        requestName: 'اسم الطلب',
        viewSubRequestFile: 'عرض ملف الطلب',
      },
      decisions: { tabTitle: 'القرارات' },
      attachments: { tabTitle: 'المرفقات' },
      partyTypesBankRuptcyFile: {
        person: 'الأفراد',
        firm: 'الشركات',
        organization: 'المؤسسات',
        government: 'جهة حكومية',
        foreignOrganization: 'شركة أو مؤسسة أجنبية',
      },
      judgementInfo: {
        header: 'صك',
        judgementCode: 'صك الحكم',
        judgementTypeName: 'نوع الحكم',
        courtName: 'المحكمة',
        subCircle: 'الدائرة',
        deliveryDate: 'تاريخ تسليم الحكم',
      },
      objectionRequests: {
        tabTitle: 'طلب الإعتراض',
        objectionAttachment: 'المرفقات الداعمة للاعتراض',
      },
      deposits: {
        tabTitle: 'الايداعات',
        depositDate: 'تاريخ الايداع',
        codeDisplayName: 'رقم الطلب',
      },
      legalCapacities: {
        bankruptcyCommissionRepresentative: 'ممثل لجنة الإفلاس',
        governmentalEntityRepresentative: 'ممثل جهة حكومية',
      },
      replyMemos: {
        tabTitle: 'مذكرة الجواب',
        cardHeader: 'مذكرة الجواب',
      },
    },
    subRequests: {
      newSubRequestExplanation: 'خدمة تتيح للأطراف برفع طلب خاص بنوع الإجراء المفتتح',
      validationSummaryTitle: 'لا يمكن تقديم الطلب للأسباب التالية',
      requestReasons: 'أسباب الطلب',
      requestReasonsWarning: 'عدد الأسباب المسموح فيها 5 كحد اقصى',
      sendRequestConfirmationMessage: 'هل أنت متأكد من إرسال الطلب؟',
      requestCode: 'رقم الطلب',
      successAlertMessage: 'رسالة نجاح',
      requestSendSuccessfully: 'تم إرسال الطلب بنجاح',
      requestUpdateSuccessfully: 'تم تحديث الطلب بنجاح',
      subRequest: 'الطلبات الفرعية',
      createNewSubRequest: 'انشاء طلب فرعي',
      errors: {
        reasonsNumberError: 'يجب إضافة سبب واحد على الاقل.',
        judgementAttachmentNotFound: 'يجب إرفاق مذكرة الاعتراض على الحكم',
      },
      mainRequestInquiry: {
        searchTitle: 'البحث عن طلب أو حكم الافتتاح',
        requestCode: 'رقم طلب الافتتاح',
        objectionRequestTitle: 'البحث عن طلب أو حكم الافتتاح',
        judgementCode: 'رقم حكم الافتتاح',
        addRepresentative: 'البحث عن طلب الافتتاح',
      },
      requestInquiry: {
        searchTitle: 'البحث عن طلب أو حكم',
        requestCode: 'رقم الطلب',
        objectionRequestTitle: 'البحث عن حكم',
        judgementCode: 'رقم الحكم',
        addRepresentative: 'البحث عن طلب',
        judgementType: 'نوع الحكم المعترض عليه',
        subRequestJudgement: 'حكم صادر في طلب فرعي',
        mainRequestJudgement: 'حكم صادر في طلب افتتاح',
        behalfHimSelf: 'اصالة عن نفسه',
        behalfItsSelf: 'اصالة عن نفسها',
      },
      requestApplicantForm: {
        legalCapacity: 'صفة مقدم الطلب',
        representativeLegalCapacity: 'صفة الممثل ',
        onBehalfOf: 'نيابة عن',
        requestParty: 'ذو المصلحة',
        legalCapacityName: 'الاسم',
        onBehalfOfName: 'الاسم',
        stakeholderType: 'نوع ذو المصلحة',
        debtsDetails: 'تفاصيل الدين',
        partnershipDetails: 'تفاصيل الشراكة',
      },
      reasonText: {
        0: 'السبب الأول',
        1: 'السبب الثاني',
        2: 'السبب الثالث',
        3: 'السبب الرابع',
        4: 'السبب الخامس',
      },
      reasonModal: {
        confirmTitle: 'تأكيد',
        message: 'هل أنت متأكد من حذف السبب؟',
        yes: 'نعم',
        no: 'لا',
      },
      reason: 'السبب',
      attachment: 'المرفق',
      attachmentName: 'اسم المرفق',
      noAttachments: 'لا يوجد مرفقات',
      noSessions: 'عذراً، لم يتم إنشاء جلسة بعد!',
      noJudgements: 'عذراً، لم يتم إصدار الحكم بعد!',
      requestDetails: 'بيانات الطلب',
      requestAuditCenterNotes: 'ملاحظات مركز تدقيق الدعاوى',
      requestApplicantName: 'اسم مقدم الطلب',
      requestApplicantInfo: 'بيانات مقدم الطلب',
      representativeInfo: 'بيانات الممثل الشخصية',
      originalPartyInfo: 'بيانات الأصيل',
      representative: 'الممثل',
      objectionRequest: {
        allowedOnlyByRequestOwner: 'لا يمكن تقديم الإعتراضات الا من قبل المحامي أو الممثل القانوني أو الممثل الإداري',
        noJudgments: 'عفواً، لم يتم العثور على احكام',
        memorandumChallenge: 'ملخص مذكرة الاعتراض على الحكم',
        memorandumChallengeAlert: 'لا يتم النظر لاي طلب لم يذكر فيه نص مذكرة الإعتراض',
        objectionJudgmentConfirmText: 'بناءً على لائحة نظام المرافعات الشرعية رقم 1 / 188 يجب على مقدم الطلب إرفاق مذكرة الإعتراض موقع عليها في كل ورقه من ورقاتها',
        judgementText: 'الحكم المعترض عليه',
        addObjectionNoteAttachment: 'أضف المرفقات الداعمة للاعتراض',
        objectionNoteAttachment: 'المرفقات الداعمة للاعتراض',
        removeObjectionNoteAttachmentMessage: 'لا يمكن استرجاع مرفق مذكرة الاعتراض بعد الحذف. هل ترغب بتأكيد الحذف؟',
        displayJudgement: 'عرض الحكم',
        header: 'نموذج طلب الاعتراض على الحكم',
        title: 'طلب الاعتراض على الحكم',
        judgementCode: 'رقم الحكم',
        fullExplanation: 'خدمة تتيح للمستفيدين من تقديم طلب لائحة اعتراضية على حكم صادر من محاكم الدرجة الأولى ويجب ان يكون حالة الحكم "غير قطعي "يمكن تقديم طلب اعتراض على الحكم خلال المدة الاعتراضية للحكم.المدة الاعتراضية للحكم هي 30 يوم للحكم المنهي للخصومة و 10 ايام للحكم العاجل وتبداء المدة من تاريخ تسليم الحكم، ويمكن للمستفيد التعديل على الطلب خلال المدة الاعتراضية وسيتم إحالة الطلب الى الدائرة القضائية بعد انتهاء المدة الاعتراضية',
        shortExplanation: 'خدمة تتيح للمستفيدين تقديم طلب لائحة اعتراضية على الأحكام الصادرة في الطلبات الرئيسية والفرعية من محاكم الدرجة الأولى',
      },
      addRepresentative: {
        bankruptcyTrustee: 'أمين الإفلاس',
        trusteeNotFound: 'عفواً، لم يتم العثور على أمين الإفلاس',
        displayJudgement: 'عرض الحكم',
        header: 'نموذج طلب إضافة ممثل',
        title: 'طلب إضافة ممثل',
        fullExplanation: 'خدمة تتيح للمستفيدين من إضافة ممثل نظامي الى قضية معينة وذلك بالبحث عن القضية برقم الطلب ثم يتم تعبئية بيانات الممثل وبيانات الوكالة  و أسباب الطلب والمرفقات ويتم التحقق من النظام اذا كان رقم الوكالة صحيح',
        shortExplanation: 'خدمة تتيح للمستفيدين من إضافة ممثل نظامي إلى طلب افلاس محدد، كما يجب أن يتضمن طلب إضافة ممثل إلى رقم طلب الافتتاح',
        partnerNotFound: 'عفوا الشريك غير مسجل بالطلب',
        employeeNotFound: 'عفوا العامل غير مسجل بالطلب',
        creditorNotFound: 'عفوا الدائن غير مسجل بالطلب',
        requestApplicantMustBeRepresentativeOrOriginalParty: 'عفوا لا يمكن لمقدم الطلب الرئيسي تقديم طلب إضافة ممثل',
        organizationDenied: 'عفوا لا يمكن تقديم الطلب بحساب الشركات',
      },
      isObjectionToTrusteeDecision: 'هل الاعتراض على قرار الأمين بتوزيع حصيلة بيع أصول التفليسة؟',
      GeneralRequest: { title: 'انشاء طلب فرعي جديد' },
      subRequestObjections: {
        objectionExchange: 'تبادل ردود الإعتراض مع مقدم الطلب',
        objectionReply: 'إرسال الرد',
        AddAttachments: 'إضافة مرفقات',
        WriteObjectionText: 'اكتب نص الرد',
        objectionApplyConfirmMessage: 'تم تقديم الرد',
        objectionReplies: 'طلبات الاعتراض',
        summaryOfObjectionResponsesWithApplicant: 'ملخص ردود الاعتراض مع مقدم الطلب',
        reply: 'الرد',
        objection: 'الإعتراض',
        replyOnObjection: 'الرد على الإعتراض',
        objectionText: 'نص الاعتراض',
        name: 'الاسم',
        role: 'الصفة',
        idType: 'نوع الهوية',
        idNumber: 'رقم الهوية',
        replyDate: 'تاريخ الرد',
        objectionDate: 'تاريخ الاعتراض',
        replyTime: 'وقت الرد',
        objectionTime: 'وقت الاعتراض',
        back: 'العودة للخلف',
        applicantName: 'اسم مقدم الاعتراض',
        unifiedNumber: 'الرقم الموحد',
        commercialRegistration: 'السجل التجاري',
        sendReply: 'إرسال الرد',
        objectionNumber: 'رقم الإعتراض',
      },
      prohibitedCompanyCommercialType: details => `يُرجى إدخال الرقم الموحد لـشركة ${details.name}  ${details.unifiedNumber}.`,
      prohibitedInstitutionCommercialType: details => `يُرجى إدخال الرقم الموحد لـمؤسسة ${details.name}  ${details.unifiedNumber}.`,

    },
    replyMemo: {
      debtDataIsNotCorrectReasons: 'أسباب عدم صحة بيانات الدين',
      debtorAgreedOnOpeningProcedure: 'هل المدين موافق على افتتاح إجراء',
      debtorNotAgreedOnOpeningProcedureReasons: 'أسباب عدم موافقة المدين على افتتاح الإجراء',
      debtorCanContinueHisBusiness: 'هل المدين قادر على الاستمرار في ممارسة نشاطة التجاري؟',
      debtorCanNotContinueHisBusinessReasons: 'أسباب عدم قدرة المدين على الاستمرار في ممارسة نشاطة التجاري',
      totalDebts: 'إجمالي الديون',
      numberOfWorkers: 'إجمالي عدد العاملين',
      totalOfAssets: 'إجمالي قيمة أصول المدين',
      debtorActivity: 'نبذة عن نشاط المدين',
      financialStatementsAttachment: 'مرفق للقوائم المالية لمدة عامين من تاريخ اليوم',
      financialStatementsAttachmentDeleteConfirmation: 'لا يمكن استرجاع مرفق القوائم المالية لمدة عامين من تاريخ اليوم بعد الحذف. هل ترغب بتأكيد الحذف؟',
      view: 'عرض مذكرة الجواب',
    },
  },
  caseDigitizationRequest: {
    caseCode: 'رقم القضية/رقم القيد',
    judgementCode: 'رقم الصك',
    caseDetails: 'تفاصيل القضية ',
    addAttachment: 'إضافة مرفق',
    requiredAttachment: 'المرفق مطلوب',
    courtName: 'اسم المحكمة',
    confirm: 'تأكيد',
    confirmMessage: 'هل أنت متأكد من حذف المرفق؟',
    yes: 'نعم',
    no: 'لا',
  },
  otp: {
    title: 'التحقق',
    code: 'رمز التحقق',
    content: 'الرجاء إدخال 4 أرقام المرسلة لرقم الجوال المسجل على الهوية رقم ',
    remainingTime: ' الوقت المتبقي لإنتهاء المدة المسموحة',
    timesUP: 'عذرًا لقد انتهت صلاحية رمز التحقق',
    otpValidationError: 'عفوًا رمز التحقق غير صحيح',
    check: 'تحقق',
    acceptAndContinue: 'قبول ومتابعة',
    resendOTP: 'إعادة إرسال',
    didNotReceiveOTP: 'لم تستلم الرمز؟',
  },
  arbitrationLawsuit: {
    title: 'بيانات قرار إيداع  حكم التحكيم',
    arbitrationRequestCode: 'رقم الطلب',
    arbitrationText: 'منطوق حكم التحكيم',
    arbitrationDate: 'تاريخ حكم التحكيم',
    exception: 'رقم صحيفة الدعوى غير صحيح',
    verificationSucceededUploadFailed: 'تم التحقق بنجاح ولم يتم إرفاق مرفق التحكيم',
    verificationSucceededUploadSucceeded: 'تم التحقق بنجاح وتم إرفاق مرفق التحكيم',
    requestCodeNotFound: 'رقم صحيفة الدعوى غير صحيح',
  },
  nafath: {
    title: 'النفاذ الوطني الموحد',
    description: 'الرجاء فتح تطبيق نفاذ وتأكيد الطلب بإختيار الرقم الظاهر',
    newNumber: 'رقم جديد',
    cancel: 'إلغاء',
    rejectedFailMessage: 'لم يتم اختيار الرقم الصحيح ، يرجى الضغط على( رقم جديد ) للمحاولة مرة أخرى',
    expiredFailMessage: 'انتهت صلاحية الطلب عبر بوابة نفاذ. يرجى الضغط على (رقم جديد) للمحاولة مرة أخرى',
  },
  judgementDeedsInquiry: {
    title: 'بيانات التحقق',
    description: 'خدمة تساعدك علي التحقق من صحة صك الحكم الصادر من وزارة العدل',
    court: 'اسم المحكمة',
    caseCode: 'رقم القضية',
    deedNumber: 'رقم الصك',
    casePartyIdentityType: 'نوع هوية احد المدعيين',
    casePartyIdentityNumber: 'رقم هوية احد المدعيين',
    partyRole: 'صفة احد المدعيين',
    inquireIdentityType: 'نوع هوية المستعلم',
    inquireIdentityNumber: 'رقم هوية المستعلم',
    submit: 'تحقق',
  },
  ariaLabels: {
    closeBtn: 'زر إغلاق',
    editBtn: 'زر تعديل',
    selected: 'محدد',
    notSelected: 'غير محدد',
    pleaseEnter: 'الرجاء إدخال ',
    edit: 'تعديل',
    delete: 'حذف',
    selectRepresentative: 'صفة الممثل، قائمة منسدلة، حدد صفة الممثل لتفعيل زر الاضافة',
    subtitle: ' عنوان فرعي',
    addAttachment: 'إضافة مرفق',
    popup: ' نافذة منبثقة',
    step: 'الخطوة',
    currentStep: 'الخطوة الحالية',
  },
  applicantRoles: {
    original: 'اصالة عن نفسي',
    representative: 'وكيل بموجب وكالة',
  },
  partyAttributes: {
    removeConfirmation: {
      title: 'تأكيد الحذف',
      message: 'سيتم حذف أطراف الدعوى. هل تريد المتابعة؟',
    },
  },
  waiverRequest: {
    newRequest: 'طلب جديد',
    title: 'طلب توثيق الصلح والتنازل عن القصاص',
    caseInfo: 'بيانات الأطراف',
    judgmentCode: 'رقم صك الحكم',
    caseCode: 'رقم القضية',
    prosecutor: 'المدعي (المتنازل)',
    defendant: 'المدعي عليه (المتنازل عنه)',
    caseType: 'نوع الطلب',
    waiverType: 'نوع التنازل',
    notes: 'الشرط',
    conditionValide: 'تم تحقق الشرط',
  },
  qaimSurvey: { urgentCaseSurveyTitle: 'تقييم الدعاوى العاجلة' },
};